import {
  initScrollClasses,
  initModal,
  initAfterInteract,
} from "./functions/core";
import {
  initDatalayer,
  readCookiePermissions,
  readCookie,
} from "./functions/cookies/core";
import { validateFormBootstrap } from "./functions/forms/validation";

import { initJquery } from "./functions/initializers/jquery";
import { initSelect2 } from "./functions/initializers/select2";
import { initDatepicker } from "./functions/initializers/datepicker";
import { toggleCollapseOnParent } from "./functions/initializers/parent-collapse";
import { initTimepicker } from "./functions/initializers/timepicker";
import { initSwiper } from "./functions/initializers/swiper";
import { initMarquee } from "./functions/initializers/marquee";
import { initFileInput } from "./functions/initializers/file-input";
import { initCookiesBox } from "./functions/initializers/cookie-box";
import { initBootstrap } from "./functions/initializers/bootstrap";
import { initPriceSlider } from "./functions/initializers/price-slider";
import AOS from "aos";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import {
  Navigation, // Enables next/prev navigation buttons
  Pagination, // Adds pagination bullets
  Scrollbar, // Enables a draggable scrollbar
  Autoplay, // Auto-plays the slides
  EffectFade, // Adds fade transition effect
  EffectCube, // Cube effect for slides
  EffectFlip, // Flip effect for slides
  EffectCoverflow, // Coverflow effect
  EffectCreative, // Creative effects (customizable)
  EffectCards, // Stack-like card effect
  Thumbs, // Enables thumbnail navigation
  FreeMode, // Allows free scrolling
  Grid, // Enables grid layout slides
  Keyboard, // Enables keyboard navigation
  Mousewheel, // Enables scrolling with a mouse wheel
  Parallax, // Enables parallax effect
  Virtual, // Virtual slides for large datasets
  Zoom, // Zoom functionality
  Controller, // Sync multiple Swipers
  // A11y, // Accessibility features
  History, // URL history tracking
  HashNavigation, // Enables hash navigation
  Manipulation, // Allows slide elements to be dynamically modified
} from "swiper/modules";
import Swiper from "swiper";
// Uncomment only the ones you actually need.
Swiper.use([
  Navigation,
  Pagination,
  Scrollbar,
  // Autoplay,
  EffectFade,
  // EffectCube,
  // EffectFlip,
  // EffectCoverflow,
  // EffectCreative,
  // EffectCards,
  Thumbs,
  FreeMode,
  // Grid,
  // Keyboard,
  // Mousewheel,
  // Parallax,
  // Virtual,
  // Zoom,
  // Controller,
  // A11y,
  // History,
  // HashNavigation,
  // Manipulation
]);

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Initialize AOS
AOS.init();

// Add functions to the global window object to give access to backend devs
document.addEventListener("DOMContentLoaded", async () => {
  console.log("Developed by LOBA - https://www.loba.com/");

  //=== Core ===//

  initScrollClasses(".header");
  window.initModal = initModal;

  // Logo switching based on scroll
  const initLogoSwitching = () => {
    const navbar = document.querySelector(".header .navbar");
    const logoContainer = document.querySelector(".navbar-brand");

    if (!navbar || !logoContainer) return;

    // SVG do logo colorido (para páginas normais e ao fazer scroll)
    const coloredLogoSVG = `<svg width="151" height="94" viewBox="0 0 151 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_6515_42586)">
                                    <path d="M95.7462 43.8505H98.0096V29.0522H95.7462V43.8505ZM48.8345 81.5836L95.7462 71.95V69.6436L43.2403 80.4267L48.8345 81.5912V81.5836ZM95.7462 2.77516V22.9423L98.0096 23.4111V0L40.9692 11.698L46.6316 12.8625L95.7462 2.77516ZM95.7462 66.3089H98.0096V51.5106H95.7462V66.3089ZM43.2403 51.5106H40.9768V66.3089H43.2403V51.5106ZM43.2403 29.0522H40.9768V43.8505H43.2403V29.0522Z" fill="#2CCDF6"/>
                                    <path d="M43.2327 51.5106H40.9692V43.8581H43.2327V51.5106ZM43.2327 29.0522V14.4732L95.7386 25.2562V29.0522H98.0021V23.4111L40.9692 11.698V29.0522H43.2327ZM95.7386 43.8505V51.503H98.0021V43.8505H95.7386ZM95.7386 91.2173L43.2327 80.4418V66.3089H40.9692V82.2868L98.0096 94V66.3164H95.7462V91.2248L95.7386 91.2173Z" fill="#1946A0"/>
                                    <path d="M7.2824 58.0137L4.40578 57.2726C3.0583 56.9021 2.35429 56.403 2.35429 55.3822C2.35429 54.2706 3.3384 53.401 5.64727 53.401C7.30511 53.401 9.22034 53.9454 10.265 54.5731L10.916 52.486C9.80323 51.8962 7.79716 51.314 5.73054 51.314C1.80924 51.314 0 53.2498 0 55.5788C0 57.5146 1.21878 58.8455 3.70176 59.4277L6.35885 60.078C8.1681 60.5166 8.93267 61.0989 8.93267 62.1424C8.93267 63.5186 7.60791 64.3353 5.6397 64.4185V66.5055C8.94024 66.3769 11.287 64.6075 11.287 61.9685C11.287 59.8814 9.89407 58.7018 7.27483 58.0061H7.2824V58.0137Z" fill="#1946A0"/>
                                    <path d="M25.9654 51.2988V53.4539C28.9934 53.5674 31.1282 55.851 31.1282 58.9286C31.1282 62.0063 28.8874 64.3882 25.7231 64.3882C22.5589 64.3882 20.3408 62.0365 20.3408 58.9286V58.8379H18.1152V58.9286C18.1152 63.2615 21.3855 66.5282 25.7231 66.5282C30.0608 66.5282 33.3689 63.2615 33.3689 58.9286C33.3689 54.5958 30.2198 51.4198 25.9578 51.2988H25.9654Z" fill="#1946A0"/>
                                    <path d="M50.1744 64.3278H43.2327V66.3089H50.1744V64.3278Z" fill="#1946A0"/>
                                    <path d="M40.9692 29.0522H35.6777V31.0561H40.9692V29.0522Z" fill="#1946A0"/>
                                    <path d="M106.874 29.0522H98.0095V31.0561H106.874V29.0522Z" fill="#1946A0"/>
                                    <path d="M105.792 35.2075H98.0095V37.2114H105.792V35.2075Z" fill="#1946A0"/>
                                    <path d="M48.3122 29.0522H43.2327V31.0561H48.3122V29.0522Z" fill="#1946A0"/>
                                    <path d="M59.5082 43.8506H61.7717V37.9675V37.5895L55.9124 29.0522H53.384V29.2262L59.5082 37.9902V43.8506Z" fill="#1946A0"/>
                                    <path d="M67.631 29.2262V29.0522H65.1026L62.665 32.5911L63.952 34.474L67.631 29.2262Z" fill="#1946A0"/>
                                    <path d="M139.448 62.7398L130.031 51.5106H128.025V66.3089H130.296V55.1176L139.728 66.3089H141.712V51.5106H139.448V62.7398Z" fill="#1946A0"/>
                                    <path d="M150.167 52.5163C150.167 52.1911 149.91 52.0248 149.569 52.0248H148.865V53.5825H149.168V53.0456H149.494L149.864 53.5825H150.228L149.811 52.9927C150.023 52.9322 150.175 52.7734 150.175 52.5163H150.167ZM149.539 52.7961H149.16V52.2819H149.539C149.743 52.2819 149.857 52.3726 149.857 52.539C149.857 52.6902 149.743 52.7961 149.539 52.7961Z" fill="#1946A0"/>
                                    <path d="M112.892 51.2914C108.555 51.2914 105.284 54.558 105.284 58.9287V59.027H107.51V58.9287C107.51 55.7755 109.773 53.4465 112.892 53.4465C116.011 53.4465 118.297 55.7755 118.297 58.9287C118.297 62.082 116.057 64.3883 112.892 64.3883V66.5207C117.275 66.5207 120.538 63.254 120.538 58.9212C120.538 54.5883 117.268 51.2838 112.892 51.2838V51.2914Z" fill="#1946A0"/>
                                    <path d="M149.463 51.2914C148.608 51.2914 147.927 51.9946 147.927 52.834C147.927 53.6809 148.6 54.3766 149.463 54.3766C150.326 54.3766 151 53.6733 151 52.834C151 51.9871 150.326 51.2914 149.463 51.2914ZM150.826 52.834C150.826 53.5826 150.235 54.2102 149.463 54.2102C148.691 54.2102 148.101 53.5901 148.101 52.8415C148.101 52.0854 148.691 51.4577 149.463 51.4577C150.235 51.4577 150.826 52.0778 150.826 52.8264V52.834Z" fill="#1946A0"/>
                                    <path d="M83.4826 29.0522H76.2229V43.8506H78.4863V31.0334H83.1268C84.936 31.0334 86.3971 32.145 86.3971 34.3455C86.3971 34.4816 86.3895 34.6177 86.3743 34.7538C86.1927 36.5157 84.8073 37.5668 83.1268 37.5668H81.7112V39.5479H83.475C86.1851 39.5479 88.5318 37.7709 88.7286 34.7538C88.7362 34.6177 88.7513 34.4891 88.7513 34.3455C88.7513 30.731 86.3138 29.0598 83.475 29.0598H83.4826V29.0522Z" fill="#1946A0"/>
                                    <path d="M76.0715 53.5069H81.3857V66.3089H83.6492V53.5069H88.706V51.5106H76.0715V53.5069Z" fill="#1946A0"/>
                                    <path d="M106.874 41.8467H98.0095V43.8505H106.874V41.8467Z" fill="#1946A0"/>
                                    <path d="M67.2146 60.0176C67.2146 62.5659 65.8444 64.4336 62.8997 64.4336C59.9549 64.4336 58.6529 62.6944 58.6529 60.0403V51.5106H56.3894V60.1991C56.3894 63.8967 58.615 66.5509 62.9072 66.5509C67.1995 66.5509 69.4856 63.6094 69.4856 60.1991V51.5106H67.2222V60.0176H67.2146Z" fill="#1946A0"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_6515_42586">
                                        <rect width="151" height="94" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>`;

    // SVG do logo branco (para homepage/404 e topo da página)
    const whiteLogoSVG = `<svg width="151" height="96" viewBox="0 0 151 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M48.8345 82.5974L95.7461 72.844V70.509L43.2402 81.4261L48.8345 82.6051V82.5974ZM95.7461 2.80964V23.2274L98.0096 23.7021V0L40.9692 11.8434L46.6316 13.0224L95.7461 2.80964Z" fill="#2CCDF6"/>
                                <path d="M95.7461 44.3954H98.0096V29.4132H95.7461V44.3954ZM95.7461 67.1329H98.0096V52.1507H95.7461V67.1329ZM43.2402 52.1507H40.9767V67.1329H43.2402V52.1507ZM43.2402 29.4132H40.9767V44.3954H43.2402V29.4132Z" fill="#B4EBFD"/>
                                <path d="M43.2326 52.1507H40.9692V44.4031H43.2326V52.1507ZM43.2326 29.4132V14.653L95.7386 25.5701V29.4132H98.002V23.7021L40.9692 11.8434V29.4132H43.2326ZM95.7386 44.3954V52.143H98.002V44.3954H95.7386ZM95.7386 92.3508L43.2326 81.4414V67.1329H40.9692V83.3094L98.0096 95.1681V67.1405H95.7461V92.3584L95.7386 92.3508Z" fill="#1946A0"/>
                                <path d="M7.2824 58.7346L4.40578 57.9844C3.0583 57.6092 2.35429 57.1039 2.35429 56.0704C2.35429 54.945 3.3384 54.0646 5.64727 54.0646C7.30511 54.0646 9.22034 54.6158 10.265 55.2513L10.916 53.1383C9.80323 52.5412 7.79716 51.9517 5.73054 51.9517C1.80924 51.9517 0 53.9115 0 56.2695C0 58.2293 1.21878 59.5767 3.70176 60.1662L6.35885 60.8246C8.1681 61.2687 8.93267 61.8581 8.93267 62.9146C8.93267 64.308 7.60791 65.1348 5.6397 65.219V67.332C8.94024 67.2018 11.287 65.4104 11.287 62.7385C11.287 60.6256 9.89407 59.4313 7.27483 58.727H7.2824V58.7346Z" fill="white"/>
                                <path d="M25.9653 51.9363V54.1182C28.9933 54.233 31.1281 56.545 31.1281 59.6609C31.1281 62.7768 28.8874 65.1883 25.7231 65.1883C22.5588 65.1883 20.3408 62.8074 20.3408 59.6609V59.569H18.1152V59.6609C18.1152 64.0476 21.3854 67.3549 25.7231 67.3549C30.0607 67.3549 33.3688 64.0476 33.3688 59.6609C33.3688 55.2742 30.2197 52.0588 25.9578 51.9363H25.9653Z" fill="white"/>
                                <path d="M50.1743 65.1271H43.2326V67.1329H50.1743V65.1271Z" fill="white"/>
                                <path d="M40.9691 29.4132H35.6777V31.442H40.9691V29.4132Z" fill="white"/>
                                <path d="M106.874 29.4132H98.0096V31.442H106.874V29.4132Z" fill="white"/>
                                <path d="M105.792 35.6449H98.0096V37.6737H105.792V35.6449Z" fill="white"/>
                                <path d="M48.3121 29.4132H43.2326V31.442H48.3121V29.4132Z" fill="white"/>
                                <path d="M59.5082 44.3954H61.7717V38.4393V38.0565L55.9125 29.4132H53.3841V29.5893L59.5082 38.4623V44.3954Z" fill="white"/>
                                <path d="M67.6309 29.5893V29.4132H65.1025L62.6649 32.9961L63.9519 34.9023L67.6309 29.5893Z" fill="white"/>
                                <path d="M139.448 63.5194L130.031 52.1506H128.025V67.1328H130.296V55.8024L139.728 67.1328H141.712V52.1506H139.448V63.5194Z" fill="white"/>
                                <path d="M150.167 53.1689C150.167 52.8397 149.91 52.6713 149.569 52.6713H148.865V54.2483H149.168V53.7048H149.494L149.864 54.2483H150.228L149.811 53.6512C150.023 53.5899 150.175 53.4292 150.175 53.1689H150.167ZM149.539 53.4521H149.16V52.9316H149.539C149.743 52.9316 149.857 53.0234 149.857 53.1919C149.857 53.345 149.743 53.4521 149.539 53.4521Z" fill="white"/>
                                <path d="M112.892 51.9287C108.555 51.9287 105.284 55.2359 105.284 59.6609V59.7605H107.51V59.6609C107.51 56.4685 109.773 54.1106 112.892 54.1106C116.011 54.1106 118.297 56.4685 118.297 59.6609C118.297 62.8534 116.057 65.1884 112.892 65.1884V67.3473C117.275 67.3473 120.538 64.04 120.538 59.6533C120.538 55.2666 117.268 51.921 112.892 51.921V51.9287Z" fill="white"/>
                                <path d="M149.463 51.9286C148.608 51.9286 147.927 52.6406 147.927 53.4904C147.927 54.3478 148.6 55.0521 149.463 55.0521C150.326 55.0521 151 54.3401 151 53.4904C151 52.6329 150.326 51.9286 149.463 51.9286ZM150.826 53.4904C150.826 54.2483 150.235 54.8837 149.463 54.8837C148.691 54.8837 148.101 54.2559 148.101 53.498C148.101 52.7324 148.691 52.097 149.463 52.097C150.235 52.097 150.826 52.7248 150.826 53.4827V53.4904Z" fill="white"/>
                                <path d="M83.4826 29.4132H76.223V44.3954H78.4864V31.419H83.1269C84.9361 31.419 86.3971 32.5444 86.3971 34.7722C86.3971 34.91 86.3895 35.0478 86.3744 35.1856C86.1927 36.9694 84.8074 38.0335 83.1269 38.0335H81.7113V40.0393H83.4751C86.1852 40.0393 88.5319 38.2402 88.7287 35.1856C88.7363 35.0478 88.7514 34.9177 88.7514 34.7722C88.7514 31.1128 86.3138 29.4209 83.4751 29.4209H83.4826V29.4132Z" fill="white"/>
                                <path d="M76.0715 54.1717H81.3857V67.1328H83.6492V54.1717H88.706V52.1506H76.0715V54.1717Z" fill="white"/>
                                <path d="M106.874 42.3667H98.0096V44.3955H106.874V42.3667Z" fill="white"/>
                                <path d="M67.2146 60.7633C67.2146 63.3433 65.8444 65.2342 62.8996 65.2342C59.9549 65.2342 58.6528 63.4734 58.6528 60.7863V52.1506H56.3894V60.947C56.3894 64.6907 58.615 67.3778 62.9072 67.3778C67.1994 67.3778 69.4856 64.3998 69.4856 60.947V52.1506H67.2221V60.7633H67.2146Z" fill="white"/>
                            </svg>`;

    let currentLogo = null;

    const switchLogo = (useWhiteLogo) => {
      const targetSVG = useWhiteLogo ? whiteLogoSVG : coloredLogoSVG;

      if (currentLogo !== targetSVG) {
        logoContainer.innerHTML = targetSVG;
        // Adiciona o aria-label de volta
        logoContainer.setAttribute("aria-label", "Type Solution Homepage");
        currentLogo = targetSVG;
      }
    };

    // Verifica se é homepage ou página 404
    const isHomepage =
      navbar.classList.contains("menu-home") ||
      navbar.parentElement.classList.contains("menu-homepage");

    // Define o logo inicial
    switchLogo(isHomepage);

    // Observa mudanças nas classes do body
    const observer = new MutationObserver(() => {
      const body = document.body;
      const isScrollTop = body.classList.contains("scroll-top");

      // No topo da página na homepage/404, usa logo branco; em qualquer outro caso, usa colorido
      switchLogo(isHomepage && isScrollTop);
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  };

  initLogoSwitching();

  //=== Cookies ===//

  initDatalayer();
  readCookiePermissions("loba_");
  window.readCookie = readCookie;
  window.initCookiesBox = initCookiesBox;

  Promise.all([
    // Swiper
    initSwiper(".swiper-from-dataset"),
    // Custom Marquee
    initMarquee(".marquee"),
    // Allow collapse to toggle a classe on any parent element
    toggleCollapseOnParent(),
    //=== Bootstrap ===//
    initBootstrap({
      critical: ["initCollapse", "initTooltip"], // Collapse is critical for the menu, everything else can be lazy loaded in most cases
    }),
  ]).then(() => {
    window.initDatepicker = initDatepicker;
    initPriceSlider(".price-range-slider"); // Initialize the price slider

    // Re-initialize price slider when accordion is opened
    document.querySelectorAll(".accordion-collapse").forEach((collapse) => {
      collapse.addEventListener("shown.bs.collapse", function () {
        const slider = this.querySelector(".price-range-slider");
        if (slider && !slider.classList.contains("slider-initialized")) {
          slider.classList.add("slider-initialized");
          initPriceSlider(".price-range-slider");
        }
      });
    });

    // Re-initialize price slider when modal is shown
    const productFilterModal = document.getElementById("product-filter");
    if (productFilterModal) {
      productFilterModal.addEventListener("shown.bs.modal", function () {
        initPriceSlider(".price-range-slider");
      });
    }

    // Fecha outros collapses no menu mobile quando um novo é aberto
    const mobileMenuCollapses = document.querySelectorAll(
      '.main-menu__mobile [data-bs-toggle="collapse"]',
    );
    mobileMenuCollapses.forEach((toggle) => {
      toggle.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href");
        const targetCollapse = document.querySelector(targetId);

        if (targetCollapse) {
          // Encontra todos os collapses abertos dentro do menu mobile
          const openCollapses = document.querySelectorAll(
            ".main-menu__mobile .collapse.show",
          );

          openCollapses.forEach((openCollapse) => {
            // Não fecha o collapse que vai abrir nem os seus pais/filhos
            if (
              openCollapse !== targetCollapse &&
              !targetCollapse.contains(openCollapse) &&
              !openCollapse.contains(targetCollapse)
            ) {
              // Remove a classe .show para fechar
              openCollapse.classList.remove("show");
            }
          });
        }
      });
    });
  });

  //=== Non-Critical Functions ===//

  Promise.all([
    initAfterInteract([
      // Datepicker
      () => initDatepicker(".datepicker-input"),
      // Timepicker
      () => initTimepicker(".timepicker-input"),
      // File Input
      () => initFileInput(".custom-file input"),
    ]),
  ]).then(() => {
    window.initTimepicker = initTimepicker;
    window.initFileInput = initFileInput;
  });

  //=== Forms ===//

  validateFormBootstrap(".needs-validation");
  initFilterSidebar();
  initCascadeFilters(".filters-sidebar");
  initModalCascadeFilters();
  initViewSwitcher();
  initQuantitySelector();
  window.initQuantitySelector = initQuantitySelector;
  initShoppingListAccordion();
  initTocScrollSpy(); // Chame a função aqui
  initSimpleFileInput(); // Adiciona a nova função de inicialização
  initTimelineAnimation(); // Adiciona a nova função da timeline
});

initJquery().then(($) => {
  function runWhenDOMReady() {
    // jQuery dependant code should be placed here

    //=== Select2 ===//
    initSelect2(".custom-select-option select");
    window.initSelect2 = initSelect2;
  }

  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    runWhenDOMReady();
  } else {
    document.addEventListener("DOMContentLoaded", runWhenDOMReady);
  }
});

//VIDEO - video component
document.querySelectorAll(".video-fullwidth").forEach((videoContainer) => {
  const video = videoContainer.querySelector("video");
  const playButton = videoContainer.querySelector(".video-play-button");

  if (video && playButton) {
    playButton.addEventListener("click", function () {
      video.play();
    });

    video.addEventListener("play", function () {
      videoContainer.classList.add("is-playing");
      video.setAttribute("controls", "true");
    });

    video.addEventListener("pause", function () {
      // Do not remove controls if video was paused by user
      if (!video.seeking) {
        videoContainer.classList.remove("is-playing");
        video.removeAttribute("controls");
      }
    });
  }
});

// SETAS DOS FILTROS
function initModalCascadeFilters() {
  var modal = document.getElementById("advancedFilterModal");
  if (!modal) return;

  function renderModalLevel(children, level) {
    // Clear all deeper levels first
    for (var l = level; l <= 2; l++) {
      var sec = document.getElementById("modal-cascade-" + l + "-section");
      var con = document.getElementById("modal-cascade-" + l);
      if (con) con.innerHTML = "";
      if (sec) sec.classList.add("d-none");
    }
    if (!children || children.length === 0) return;

    var section = document.getElementById(
      "modal-cascade-" + level + "-section",
    );
    var container = document.getElementById("modal-cascade-" + level);
    if (!section || !container) return;

    section.classList.remove("d-none");
    children.forEach(function (child, i) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className =
        "btn btn-sm rounded-pill btn-outline-dark modal-cascade-btn";
      btn.setAttribute("data-cascade-level", level);
      btn.setAttribute("data-cascade-index", i);
      btn.setAttribute("data-children", JSON.stringify(child.children || []));
      btn.textContent = child.label;
      container.appendChild(btn);
    });
  }

  modal.addEventListener("click", function (e) {
    var btn = e.target.closest(".modal-cascade-btn");
    if (!btn) return;

    var level = parseInt(btn.getAttribute("data-cascade-level"), 10);
    var container = document.getElementById("modal-cascade-" + level);
    if (!container) return;

    var isActive = btn.classList.contains("active");

    // Deactivate all siblings
    container.querySelectorAll(".modal-cascade-btn").forEach(function (b) {
      b.classList.remove("active");
    });

    var children = [];
    try {
      children = JSON.parse(btn.getAttribute("data-children") || "[]");
    } catch (ex) {}

    if (!isActive) {
      btn.classList.add("active");
      renderModalLevel(children, level + 1);
    } else {
      renderModalLevel([], level + 1);
    }
  });
}

function initCascadeFilters(containerSelector) {
  var container = containerSelector
    ? document.querySelector(containerSelector)
    : document;
  if (!container) return;

  var CASCADE_LIMIT = 7;
  var cascadeData = window.cascadeData || [];

  // Read label HTML from the server-rendered level-0 button (contains translations)
  var templateBtn = container.querySelector(
    '.cascade-show-toggle[data-cascade-toggle-level="0"]',
  );
  var toggleInnerHTML = templateBtn
    ? templateBtn.innerHTML
    : '<span class="cascade-label-more">Mostrar mais</span><span class="cascade-label-less d-none">Mostrar menos</span>';

  function getList(level) {
    return container.querySelector('[data-cascade-list="' + level + '"]');
  }

  function getToggleBtn(level) {
    return container.querySelector(
      '.cascade-show-toggle[data-cascade-toggle-level="' + level + '"]',
    );
  }

  function initCascadeToggle(level) {
    var btn = getToggleBtn(level);
    if (!btn) return;
    btn.addEventListener("click", function () {
      var expanded = this.dataset.expanded === "1";
      var list = getList(level);
      if (!list) return;
      list.querySelectorAll(".cascade-hidden-" + level).forEach(function (el) {
        el.classList.toggle("d-none", expanded);
      });
      this.dataset.expanded = expanded ? "0" : "1";
      this.querySelector(".cascade-label-more").classList.toggle(
        "d-none",
        !expanded,
      );
      this.querySelector(".cascade-label-less").classList.toggle(
        "d-none",
        expanded,
      );
    });
  }

  function renderCascadeLevel(children, level) {
    var list = getList(level);
    if (!list) return;
    var existingToggle = getToggleBtn(level);
    if (existingToggle) existingToggle.remove();
    list.innerHTML = "";
    if (!children || children.length === 0) return;

    children.forEach(function (child, i) {
      var li = document.createElement("li");
      li.className = "form-check my-1";
      if (i >= CASCADE_LIMIT) {
        li.classList.add("cascade-hidden-" + level, "d-none");
      }
      var checked = child.active ? " checked" : "";
      li.innerHTML =
        '<input class="form-check-input" type="checkbox" id="cascade-' +
        containerSelector +
        "-" +
        level +
        "-" +
        i +
        '"' +
        checked +
        ">" +
        '<label class="form-check-label small" for="cascade-' +
        containerSelector +
        "-" +
        level +
        "-" +
        i +
        '">' +
        child.label +
        "</label>";
      list.appendChild(li);

      var input = li.querySelector("input");
      if (child.children && child.children.length > 0) {
        input.addEventListener("change", function () {
          if (this.checked) {
            list
              .querySelectorAll("input[type=checkbox]")
              .forEach(function (cb) {
                if (cb !== input) cb.checked = false;
              });
            renderCascadeLevel(child.children, level + 1);
          } else {
            renderCascadeLevel([], level + 1);
          }
        });
        if (child.active) {
          renderCascadeLevel(child.children, level + 1);
        }
      }
    });

    if (children.length > CASCADE_LIMIT) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "btn btn-link btn-sm text-muted px-0 cascade-show-toggle";
      btn.setAttribute("data-cascade-toggle-level", level);
      btn.innerHTML = toggleInnerHTML;
      list.insertAdjacentElement("afterend", btn);
      initCascadeToggle(level);
    }
  }

  // Level 0 — application list click
  container.querySelectorAll(".cascade-item").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      container.querySelectorAll(".cascade-item").forEach(function (l) {
        l.classList.remove("active", "text-primary", "fw-semibold");
        l.classList.add("text-muted");
      });
      this.classList.add("active", "text-primary", "fw-semibold");
      this.classList.remove("text-muted");
      var idx = parseInt(this.getAttribute("data-cascade-index"), 10);
      var children =
        cascadeData[idx] && cascadeData[idx].children
          ? cascadeData[idx].children
          : [];
      renderCascadeLevel(children, 1);
    });
  });

  // Level 0 toggle (items hidden server-side)
  initCascadeToggle(0);

  // Init: render active application's children on load
  var activeLink = container.querySelector(".cascade-item.active");
  if (activeLink) {
    var idx = parseInt(activeLink.getAttribute("data-cascade-index"), 10);
    var children =
      cascadeData[idx] && cascadeData[idx].children
        ? cascadeData[idx].children
        : [];
    renderCascadeLevel(children, 1);
  }
}

function initFilterSidebar() {
  // Search filter
  document.querySelectorAll("[data-filter-search]").forEach(function (input) {
    input.addEventListener("input", function () {
      var query = this.value.toLowerCase();
      var key = this.getAttribute("data-filter-search");
      document
        .querySelectorAll('[data-filter-item="' + key + '"]')
        .forEach(function (item) {
          var label = item.querySelector("label").textContent.toLowerCase();
          item.style.display = label.includes(query) ? "" : "none";
        });
    });
  });

  const filterLists = document.querySelectorAll(
    ".filters-sidebar .filter-list",
  );

  filterLists.forEach((list) => {
    const items = list.querySelectorAll("a");
    items.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        // Toggle apenas o item clicado (não desativa os outros)
        if (this.classList.contains("active")) {
          this.classList.remove("active", "text-primary", "fw-semibold");
          this.classList.add("text-body-secondary");
        } else {
          this.classList.add("active", "text-primary", "fw-semibold");
          this.classList.remove("text-body-secondary");
        }

        // Navigate to the URL
        const url = this.getAttribute("href");
        if (url && url !== "#") {
          window.location.href = url;
        }
      });
    });
  });

  const sizeFilters = document.querySelectorAll(
    ".filters-sidebar .sizes-filter",
  );
  sizeFilters.forEach((container) => {
    const buttons = container.querySelectorAll(".btn");
    buttons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        this.classList.toggle("active");
      });
    });
  });

  const colorFilters = document.querySelectorAll(
    ".filters-sidebar .colors-filter",
  );
  colorFilters.forEach((container) => {
    const items = container.querySelectorAll(".color-filter-item");
    items.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        // Deactivate any other active item
        const currentActive = container.querySelector(".active");
        if (currentActive && currentActive !== this) {
          currentActive.classList.remove("active");
        }

        // Toggle the clicked item
        this.classList.toggle("active");
      });
    });
  });

  // Search checkbox show more/less toggle
  document.querySelectorAll(".search-checkbox-show-toggle").forEach((btn) => {
    btn.addEventListener("click", function () {
      const key = this.getAttribute("data-checkbox-toggle-key");
      const hiddenItems = document.querySelectorAll(".search-checkbox-hidden-" + key);
      const labelMore = this.querySelector(".search-checkbox-label-more");
      const labelLess = this.querySelector(".search-checkbox-label-less");
      const isExpanded = labelLess && !labelLess.classList.contains("d-none");

      hiddenItems.forEach((item) => {
        item.classList.toggle("d-none", isExpanded);
      });

      if (labelMore) labelMore.classList.toggle("d-none", !isExpanded);
      if (labelLess) labelLess.classList.toggle("d-none", isExpanded);
    });
  });
}

// ALTERAÇÃO DA VISTA DO PRODUTO
function initViewSwitcher() {
  const toggleButtons = document.querySelectorAll("[data-view-toggle]");
  const views = document.querySelectorAll(".product-view");

  if (!toggleButtons.length || !views.length) return;

  toggleButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const targetViewId = this.dataset.viewTarget;
      const targetView = document.querySelector(targetViewId);

      // Update button active state
      toggleButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      // Update view visibility
      views.forEach((view) => view.classList.add("d-none"));
      if (targetView) {
        targetView.classList.remove("d-none");
      }
    });
  });
}

// SHOPPING LIST ACCORDION - collapse via seta sem conflitar com offcanvas
function initShoppingListAccordion() {
  document.querySelectorAll("[data-collapse-target]").forEach(function (arrow) {
    arrow.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      var targetSelector = this.getAttribute("data-collapse-target");
      var collapseEl = document.querySelector(targetSelector);
      if (!collapseEl) return;

      var Collapse = (await import("bootstrap/js/dist/collapse")).default;
      Collapse.getOrCreateInstance(collapseEl).toggle();

      // Toggle visual state on the arrow
      this.classList.toggle("collapsed");
    });
  });
}

// QUANTIDADE DE PRODUTOS
let quantitySelectorInitialized = false;

function initQuantitySelector() {
  // Use event delegation - only register listeners once
  if (quantitySelectorInitialized) {
    // Still update initial state for newly added elements
    document.querySelectorAll('.quantity-selector').forEach((selector) => {
      const minusBtn = selector.querySelector('[data-quantity="minus"]');
      const input = selector.querySelector('[data-quantity="input"]');
      if (minusBtn && input) {
        minusBtn.disabled = parseInt(input.value, 10) <= 1;
      }
    });
    return;
  }

  // Register click listener for quantity buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quantity]');
    if (!btn || !btn.closest('.quantity-selector')) return;

    const selector = btn.closest('.quantity-selector');
    const input = selector.querySelector('[data-quantity="input"]');
    const minusBtn = selector.querySelector('[data-quantity="minus"]');
    
    if (!input) return;

    let currentValue = parseInt(input.value, 10) || 1;

    if (btn.dataset.quantity === 'minus' && currentValue > 1) {
      input.value = currentValue - 1;
    } else if (btn.dataset.quantity === 'plus') {
      input.value = currentValue + 1;
    }

    // Update minus button state
    if (minusBtn) {
      minusBtn.disabled = parseInt(input.value, 10) <= 1;
    }
  });

  // Register change listener for quantity input
  document.addEventListener('change', function (e) {
    const input = e.target.closest('[data-quantity="input"]');
    if (!input || !input.closest('.quantity-selector')) return;

    if (parseInt(input.value, 10) < 1 || isNaN(parseInt(input.value, 10))) {
      input.value = 1;
    }

    const selector = input.closest('.quantity-selector');
    const minusBtn = selector.querySelector('[data-quantity="minus"]');
    if (minusBtn) {
      minusBtn.disabled = parseInt(input.value, 10) <= 1;
    }
  });

  // Initial state for already present elements
  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const minusBtn = selector.querySelector('[data-quantity="minus"]');
    const input = selector.querySelector('[data-quantity="input"]');
    if (minusBtn && input) {
      minusBtn.disabled = parseInt(input.value, 10) <= 1;
    }
  });

  quantitySelectorInitialized = true;
}

// BARRA DE PESQUISA
document.getElementById("open-search").addEventListener("click", () => {
  document
    .querySelector(".menu-mobile-label__container .search-input")
    .classList.add("show");
  document
    .querySelector(".menu-mobile-label__container .search-input input")
    .focus();
  document.querySelector(".navbar-brand").classList.add("d-none");
});
document
  .querySelector(".menu-mobile-label__container .close-input-close")
  .addEventListener("click", () => {
    document
      .querySelector(".menu-mobile-label__container .search-input")
      .classList.remove("show");
    document.querySelector(".navbar-brand").classList.remove("d-none");
  });

// RECUPERAR PASSWORD - FORMULÁRIO
document.addEventListener("DOMContentLoaded", function () {
  var forgotLink = document.getElementById("forgot-password-link");
  var loginForm = document.getElementById("login-form");
  var recoverForm = document.getElementById("recover-pw-form");
  if (forgotLink && loginForm && recoverForm) {
    forgotLink.addEventListener("click", function (e) {
      e.preventDefault();
      loginForm.classList.add("d-none");
      recoverForm.classList.remove("d-none");
    });
  }
});

// TOGGLE CLASS ACTIVE SEARCH FILTERS
document.addEventListener("DOMContentLoaded", function () {
  // Toggle active state for search filter buttons and show/hide close icon
  document.querySelectorAll(".search-filter .btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      btn.classList.toggle("active");
      var svg = btn.querySelector(".close-btn");
      if (svg) {
        if (btn.classList.contains("active")) {
          svg.classList.remove("d-none");
        } else {
          svg.classList.add("d-none");
        }
      }

      // Atualizar contador de filtros ativos se existir o .counter-filters
      var counter = document.querySelector(".counter-filters");
      var modal = document.getElementById("advancedFilterModal");
      if (counter && modal) {
        // Conta os botões ativos dentro do modal
        var activeFilters = modal.querySelectorAll(
          ".search-filter .btn.active",
        ).length;
        counter.textContent = activeFilters;
      }
    });
  });

  // Sticky CTA Newsletter com GSAP ScrollTrigger
  const floatingNewsletter = document.querySelector(
    ".cta-newsletter__floating",
  );

  if (floatingNewsletter && typeof ScrollTrigger !== "undefined") {
    const parentContainer = floatingNewsletter.parentElement; // Obtém o contentor pai direto

    if (parentContainer) {
      ScrollTrigger.matchMedia({
        // Media query para ecrãs maiores que 992px
        "(min-width: 992px)": function () {
          ScrollTrigger.create({
            trigger: floatingNewsletter,
            pin: true,
            start: "top top",
            endTrigger: parentContainer, // Define o pai como o gatilho final
            end: "bottom bottom", // Termina quando a parte inferior do pai atinge a parte inferior da janela
            pinSpacing: false,
            // markers: true, // Descomente para depuração
          });
        },
      });
    }
  }

  const floatingLinks = document.querySelector(".cta-newsletter__links");

  if (floatingLinks && typeof ScrollTrigger !== "undefined") {
    const colWrapper = floatingLinks.closest('[class*="col-"]');
    const contentCol = colWrapper ? colWrapper.nextElementSibling : null;
    const endTarget = contentCol || floatingLinks.closest(".row");
    // Use the inner container so height = natural TOC height, not flex-stretched full-row height
    const pinTarget = floatingLinks.querySelector(":scope > div") || floatingLinks;

    if (endTarget) {
      const mmLinks = gsap.matchMedia();
      mmLinks.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
          trigger: pinTarget,
          pin: pinTarget,
          start: "top 20px",
          endTrigger: endTarget,
          end: "bottom bottom",
          pinSpacing: false,
          invalidateOnRefresh: true,
          // markers: true,
        });
      });
    }
  }

  const videoFullwidthSticky = document.querySelector(
    ".video-fullwidth.video-fullwidth-sticky",
  );
  if (videoFullwidthSticky && footer && typeof ScrollTrigger !== "undefined") {
    ScrollTrigger.matchMedia({
      "(min-width: 992px)": function () {
        ScrollTrigger.create({
          trigger: videoFullwidthSticky,
          pin: true,
          start: "top top",

          // Esta é a nova lógica, muito mais fiável
          end: () =>
            "+=" +
            (footer.offsetTop -
              (videoFullwidthSticky.offsetTop +
                videoFullwidthSticky.offsetHeight) -
              300),

          pinSpacing: false,

          // Remove os marcadores quando tudo estiver a funcionar como queres
          //markers: true,
        });
      },
    });
  }

  const scrollableSidebars = document.querySelectorAll(".scrollable-sidebar");

  if (
    scrollableSidebars.length > 0 &&
    footer &&
    typeof ScrollTrigger !== "undefined"
  ) {
    scrollableSidebars.forEach((sidebar) => {
      ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
          // Procura o container .row mais próximo (dentro de .checkout__b2b ou outro)
          const parentRow =
            sidebar.closest(".row") || sidebar.parentElement.closest(".row");

          ScrollTrigger.create({
            trigger: sidebar,
            pin: true,
            start: "top 20px", // Dá um pequeno respiro de 20px do topo
            end: () => {
              // Se encontrar o .row pai, usa a sua altura; caso contrário, usa o footer
              if (parentRow) {
                const contextHeight = parentRow.offsetHeight;
                const sidebarHeight = sidebar.offsetHeight;
                return `+=${contextHeight - sidebarHeight}`;
              }
              // Fallback: usa o footer como referência
              return "bottom bottom";
            },
            pinSpacing: false,
            invalidateOnRefresh: true,
            // markers: true, // Ative isto para ver visualmente onde o "end" está a ser calculado
          });
        },

        "(max-width: 991px)": function () {},
      }); // Fim do matchMedia
    });    

    // Recalcula o ScrollTrigger quando accordions/collapses mudam a altura do conteúdo
    document
      .querySelectorAll(".accordion-collapse, .collapse")
      .forEach((collapse) => {
        collapse.addEventListener("shown.bs.collapse", () =>
          ScrollTrigger.refresh(),
        );
        collapse.addEventListener("hidden.bs.collapse", () =>
          ScrollTrigger.refresh(),
        );
      });
  }

  const scrollableSidebars_menuar = document.querySelectorAll(".scrollable-sidebar__menu-ar");

  if (
    scrollableSidebars_menuar.length > 0 &&
    footer &&
    typeof ScrollTrigger !== "undefined"
  ) {
    scrollableSidebars_menuar.forEach((sidebar) => {
      ScrollTrigger.matchMedia({
        "(min-width: 1200px)": function () {
          // Procura o container .row mais próximo (dentro de .checkout__b2b ou outro)
          const parentRow =
            sidebar.closest(".row") || sidebar.parentElement.closest(".row");

          ScrollTrigger.create({
            trigger: sidebar,
            pin: true,
            start: "top 20px", // Dá um pequeno respiro de 20px do topo
            end: () => {
              // Se encontrar o .row pai, usa a sua altura; caso contrário, usa o footer
              if (parentRow) {
                const contextHeight = parentRow.offsetHeight;
                const sidebarHeight = sidebar.offsetHeight;
                return `+=${contextHeight - sidebarHeight}`;
              }
              // Fallback: usa o footer como referência
              return "bottom bottom";
            },
            pinSpacing: false,
            invalidateOnRefresh: true,
            // markers: true, // Ative isto para ver visualmente onde o "end" está a ser calculado
          });
        },

        "(max-width: 1199px)": function () {},
      }); // Fim do matchMedia
    });

    document
      .querySelectorAll(".accordion-collapse, .collapse")
      .forEach((collapse) => {
        collapse.addEventListener("shown.bs.collapse", () =>
          ScrollTrigger.refresh(),
        );
        collapse.addEventListener("hidden.bs.collapse", () =>
          ScrollTrigger.refresh(),
        );
      });
  }

  // Sticky bottom: Order Summary Mobile com GSAP ScrollTrigger
  const orderSummaryMobile = document.querySelector(".order-summary-mobile");

  if (orderSummaryMobile && footer && typeof ScrollTrigger !== "undefined") {
    const mm = gsap.matchMedia();
    mm.add("(max-width: 991px)", () => {
      ScrollTrigger.create({
        trigger: footer,
        start: "top bottom",
        onEnter: () => orderSummaryMobile.classList.add("is-grounded"),
        onLeaveBack: () => orderSummaryMobile.classList.remove("is-grounded"),
      });
    });
  }

  // 1. Seleciona TODOS os elementos (NodeList)
});

// Seleciona todos os '.product-info'
const productInfos = document.querySelectorAll(".product-info");

if (productInfos.length > 0 && typeof ScrollTrigger !== "undefined") {
  productInfos.forEach((productInfo) => {
    const specContainer = productInfo.nextElementSibling;

    if (
      specContainer &&
      specContainer.classList.contains("specifications-container")
    ) {
      ScrollTrigger.matchMedia({
        "(min-width: 992px)": function () {
          const headerOffset = 80;

          ScrollTrigger.create({
            trigger: productInfo,
            pin: productInfo,
            start: `top top`,

            pinSpacing: false,

            endTrigger: specContainer,

            end: () => `bottom top+=${headerOffset + productInfo.offsetHeight}`,

            markers: false,
          });
        },
      });
    }
  });
}

function initTimelineAnimation() {
  const timelineSection = document.querySelector(".timeline-section");
  const timelineProgressLine = document.querySelector(
    ".timeline-line-progress",
  );
  const timelineItems = document.querySelectorAll(".timeline-item");

  if (timelineSection && timelineProgressLine) {
    gsap.to(timelineProgressLine, {
      height: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: timelineSection,
        start: "top 60%",
        end: "bottom 40%",
        scrub: true,
      },
    });
  }

  if (timelineItems.length > 0) {
    timelineItems.forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: "top 60%",
        toggleClass: "is-active", // A classe a adicionar/remover

        // Ordem: onEnter, onLeave, onEnterBack, onLeaveBack
        // "play" = adiciona classe
        // "reverse" = remove classe
        // "none" = não faz nada
        toggleActions: "play none none reverse",
      });
    });
  }
}

// Adicione esta função
function initTocScrollSpy() {
  const links = document.querySelectorAll(
    ".floating-links-list .floating-link",
  );
  if (!links.length) return;

  // Adiciona evento de clique para scroll suave e ativação imediata
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href");

      // Feedback visual imediato
      links.forEach((l) => {
        l.classList.remove("active", "text-primary");
        l.classList.add("text-dark");
      });
      link.classList.add("active", "text-primary");
      link.classList.remove("text-dark");

      // Scroll suave para a secção
      gsap.to(window, {
        duration: 1,
        scrollTo: { y: targetId, offsetY: 100 }, // offsetY ajusta o espaçamento do topo
        ease: "power2.inOut",
      });
    });
  });

  // Cria um ScrollTrigger para cada secção alvo para atualizar ao fazer scroll
  links.forEach((link) => {
    const targetId = link.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      ScrollTrigger.create({
        trigger: targetElement,
        start: "top center",
        end: "bottom center",
        onToggle: (self) => {
          if (self.isActive) {
            // Remove a classe de todos os outros links
            links.forEach((l) => {
              l.classList.remove("active", "text-primary");
              l.classList.add("text-dark");
            });
            // Adiciona a classe ao link atual
            link.classList.add("active", "text-primary");
            link.classList.remove("text-dark");
          }
        },
      });
    }
  });
}

//AR - UPLOAD CUSTOM FILE INPUT
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".drop-zone").forEach((dropZoneElement) => {
    const inputElement = dropZoneElement.querySelector(".drop-zone__input");

    dropZoneElement.addEventListener("click", (e) => {
      inputElement.click();
    });

    inputElement.addEventListener("change", (e) => {
      handleFiles(inputElement, dropZoneElement);
    });

    dropZoneElement.addEventListener("dragover", (e) => {
      e.preventDefault();
      dropZoneElement.classList.add("drop-zone--over");
    });

    ["dragleave", "dragend"].forEach((type) => {
      dropZoneElement.addEventListener(type, (e) => {
        dropZoneElement.classList.remove("drop-zone--over");
      });
    });

    dropZoneElement.addEventListener("drop", (e) => {
      e.preventDefault();

      if (e.dataTransfer.files.length) {
        inputElement.files = e.dataTransfer.files;
        handleFiles(inputElement, dropZoneElement);
      }

      dropZoneElement.classList.remove("drop-zone--over");
    });
  });

  function handleFiles(inputElement, dropZoneElement) {
    const files = inputElement.files;
    const parentContainer = dropZoneElement.parentElement; // O .rounded-3 que contém tudo
    const errorMessageContainer = parentContainer.querySelector(
      ".drop-zone__error-message",
    );
    const promptContainer = dropZoneElement.querySelector(
      ".drop-zone__prompt-container",
    );
    const previewGrid = parentContainer.querySelector(
      ".drop-zone__preview-grid",
    );

    // Limpa erros e pré-visualizações anteriores
    if (errorMessageContainer) errorMessageContainer.textContent = "";
    if (previewGrid) previewGrid.innerHTML = "";
    inputElement.setCustomValidity("");

    // Mostra o prompt e esconde a grelha por defeito
    if (promptContainer) promptContainer.style.display = "flex";
    if (previewGrid) previewGrid.style.display = "none";
    
    // Atualiza o texto do prompt com o nome do arquivo
    updateDropZonePrompt(dropZoneElement, inputElement);

    // Validação para inputs que permitem múltiplos ficheiros
    if (inputElement.multiple) {
      const maxFiles = 4;
      const maxSize = 5 * 1024 * 1024; // 5MB

      if (files.length > maxFiles) {
        const error = `Pode selecionar no máximo ${maxFiles} imagens.`;
        if (errorMessageContainer) errorMessageContainer.textContent = error;
        inputElement.setCustomValidity(error); // Para validação de formulário do browser
        inputElement.value = ""; // Limpa a seleção
        return;
      }

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > maxSize) {
          const error = `O ficheiro ${files[i].name} excede o tamanho máximo de 5MB.`;
          if (errorMessageContainer) errorMessageContainer.textContent = error;
          inputElement.setCustomValidity(error);
          inputElement.value = "";
          return;
        }
      }

      // Se exatamente 4 ficheiros forem selecionados, mostra a pré-visualização
      if (files.length === 4 && previewGrid) {
        if (promptContainer) promptContainer.style.display = "none";
        previewGrid.style.display = "flex";

        Array.from(files).forEach((file) => {
          const reader = new FileReader();
          reader.onload = function (e) {
            const col = document.createElement("div");
            col.className = "col-6 col-md-3"; // Ajustado para 4 colunas em ecrãs médios e 2 em pequenos

            const previewItem = document.createElement("div");
            previewItem.className = "preview-item";

            const img = document.createElement("img");
            img.src = e.target.result;
            img.className = "rounded-3";

            const overlay = document.createElement("div");
            overlay.className = "preview-item__overlay";

            const deleteBtn = document.createElement("button");
            deleteBtn.type = "button";
            deleteBtn.className =
              "preview-item__delete-btn btn btn-light rounded-circle";
            deleteBtn.innerHTML = `<svg class="icon icon-trash text-dark"><use xlink:href="/starter-powersales/public/assets/icomoon/symbol-defs.svg#icon-trash"></use></svg>`;

            // Adicionar evento de clique para remover a imagem (lógica a ser implementada)
            deleteBtn.addEventListener("click", function () {
              // Aqui pode adicionar a lógica para remover o ficheiro da seleção
              console.log(`Remover ficheiro: ${file.name}`);
              col.remove();
              // Nota: A remoção visual não remove o ficheiro do input.
              // Seria necessária uma gestão de estado mais complexa para isso.
            });

            previewItem.appendChild(img);
            previewItem.appendChild(overlay);
            previewItem.appendChild(deleteBtn);
            col.appendChild(previewItem);
            previewGrid.appendChild(col);
          };
          reader.readAsDataURL(file);
        });
      }
    }
  }
  
  // Helper function to update prompt text with filename(s)
  function updateDropZonePrompt(dropZoneElement, fileInput) {
    const promptElement = dropZoneElement.querySelector('.drop-zone__prompt[data-input-id]');
    if (!promptElement) return;
    
    const inputId = promptElement.getAttribute('data-input-id');
    if (inputId !== fileInput.id) return;
    
    const promptSpan = promptElement.querySelector('span:first-child');
    if (!promptSpan) return;
    
    if (fileInput.files.length > 0) {
      // Show filename(s)
      const fileNames = Array.from(fileInput.files)
        .map(file => file.name)
        .join(', ');
      promptSpan.innerHTML = fileNames;
      promptElement.classList.add('file-selected');
    } else {
      // Reset to original text
      const originalText = promptElement.getAttribute('data-original-text') || 'Click to upload';
      promptSpan.innerHTML = originalText + '<span class="d-none d-lg-inline-block text-body fw-normal ms-1 text-body-secondary">or drag and drop</span>';
      promptElement.classList.remove('file-selected');
    }
  }
});

//AR - UPLOAD CUSTOM FILE INPUT (SIMPLE)
function initSimpleFileInput() {
  const simpleFileInputs = document.querySelectorAll(".input-file-simple");

  simpleFileInputs.forEach((container) => {
    const input = container.querySelector(".input-file-simple__input");
    const nameSpan = container.querySelector(".input-file-simple__name");

    if (input && nameSpan) {
      input.addEventListener("change", function () {
        if (this.files.length > 0) {
          nameSpan.textContent = this.files[0].name;
          nameSpan.style.display = "inline";
        } else {
          nameSpan.style.display = "none";
        }
      });
    }
  });
}

$(".ar__select")
  .on("select2:open", function () {
    $(".select2-container--open").addClass("ar__select__results");
    $(this).closest(".custom-select-option").addClass("open-select");

    // Adiciona classe específica se o select tiver ar__select--wide-dropdown
    if ($(this).hasClass("ar__select--wide-dropdown")) {
      $(".select2-container--open").addClass("ar__select__results--wide");
    }
  })
  .on("select2:close", function () {
    $(this).closest(".custom-select-option").removeClass("open-select");
    $(".select2-container--open").removeClass("ar__select__results--wide");
  });

document.addEventListener("DOMContentLoaded", function () {
  const rangeSlider = document.getElementById("month-range");
  const tooltip = document.querySelector(".month-range-tooltip");

  if (!rangeSlider || !tooltip) return;

  function updateTooltip() {
    const value = rangeSlider.value;
    const min = rangeSlider.min;
    const max = rangeSlider.max;
    const sliderWidth = rangeSlider.offsetWidth;
    const thumbWidth = 24; // A largura do seu thumb

    // Calcula a posição percentual do thumb
    const percent = (value - min) / (max - min);

    // Calcula a posição em pixels
    // A fórmula ajusta o posicionamento para que o centro do tooltip se alinhe com o centro do thumb
    const tooltipPosition =
      percent * (sliderWidth - thumbWidth) + thumbWidth / 2;

    tooltip.innerHTML = value;
    tooltip.style.left = `${tooltipPosition}px`;
  }

  // Atualiza na carga inicial e sempre que o valor mudar
  rangeSlider.addEventListener("input", updateTooltip);

  // Garante que o tooltip está correto ao carregar a página
  updateTooltip();

  // Atualiza a cor de preenchimento do slider
  function updateSliderFill() {
    // O cálculo da percentagem continua exatamente o mesmo
    const percent =
      ((rangeSlider.value - rangeSlider.min) /
        (rangeSlider.max - rangeSlider.min)) *
      100;

    // CHAVE: Em vez de mudar o 'background', definimos o valor da nossa variável CSS.
    rangeSlider.style.setProperty("--fill-percent", `${percent}%`);
  }

  // O resto do teu código continua igual
  rangeSlider.addEventListener("input", updateSliderFill);
  updateSliderFill(); // Call on load

  window.addEventListener("resize", updateTooltip);
});

document.addEventListener("DOMContentLoaded", function () {
  const budgetTable = document.querySelector(".table__budgets");

  // ... (Seletores de botões e de resumo mantidos) ...

  const bulkActionButton = document.getElementById(
    "delete-selected-budgets-btn",
  );

  const bulkActionUsersButton = document.getElementById(
    "delete-selected-users-btn",
  );

  const bulkActionDocsButton = document.getElementById(
    "regularize-selected-docs-btn",
  );

  const summaryTextCount = document.querySelector(".summary-text-count");

  const summaryTextValue = document.querySelector(".summary-text-value");

  const summaryBarWrapper = document.getElementById("summary-bar-wrapper");

  if (!budgetTable) return;

  const rowCheckboxes = budgetTable.querySelectorAll(
    ".table-body .form-check-input, .card .form-check-input",
  );

  const dataRows = budgetTable.querySelectorAll(".table-body");

  // --- FUNÇÕES DE CÁLCULO E FORMATAÇÃO (Mantidas) ---

  const parseValue = (textNode) => {
    if (!textNode || !textNode.textContent) return 0;

    let text = textNode.textContent;

    // 1. Isola a string que contém o número e moeda, ignorando o texto inicial ("Total documento")

    // Procura: Dígitos/vírgulas/pontos seguidos por zero ou mais espaços, terminando em €

    const currencyMatch = text.match(/[\d.,]+(\s*€)/);

    if (currencyMatch) {
      text = currencyMatch[0]; // Captura apenas o bloco monetário (ex: "1.000,50 €")
    } else {
      // FALLBACK: Se não encontrar o padrão, usa o texto todo limpo de espaços

      text = text.trim();
    }

    // 2. Limpeza Agressiva (Formato PT-PT)

    text = text.replace("€", "");

    text = text.replace(/\s/g, ""); // Remove TODOS os espaços (incluindo &nbsp;)

    text = text.replace(/\./g, ""); // Remove separadores de milhares (pontos)

    text = text.replace(",", "."); // Troca a vírgula decimal por ponto

    // 3. Conversão final

    const value = parseFloat(text);

    // DEBUGGING CRÍTICO:

    // console.log(
    //   `[DEBUG PARSE] Original Text: "${textNode.textContent.trim()}"`
    // );

    // console.log(`[DEBUG PARSE] Final String: "${text}", Valor: ${value}`);

    return value || 0;
  };

  const formatCurrency = (value) => {
    return value.toLocaleString("pt-PT", {
      style: "currency",

      currency: "EUR",
    });
  };

  /**

     * CORREÇÃO: Procura pela coluna "Total documento" de forma dinâmica

     */

  const calculateTotals = (isSelected = false) => {
    let count = 0;

    let total = 0;

    dataRows.forEach((row) => {
      const checkbox = row.querySelector(".form-check-input");

      const isRowChecked = checkbox && checkbox.checked;

      // Apenas processa linhas que devem ser contabilizadas

      if (isSelected && !isRowChecked) return;

      const allItems = row.querySelectorAll(".table-item");

      // DEBUG: Mostra quantos itens foram encontrados

      // console.log(
      //   `[DEBUG ROW] Encontrados ${allItems.length} .table-item nesta linha`
      // );

      // Tenta encontrar o elemento com "Total documento" pelo texto

      let valueElement = null;

      // Método 1: Procura por índice (testa vários índices comuns)

      const indicesToTry = [4, 3, 5]; // Tenta 5ª, 4ª e 6ª colunas

      for (let i of indicesToTry) {
        if (allItems[i]) {
          // console.log(
          //   `[DEBUG INDEX ${i}] Texto: "${allItems[i].textContent.trim()}"`
          // );

          // Verifica se contém números e símbolo €

          if (allItems[i].textContent.match(/[\d.,]+\s*€/)) {
            valueElement = allItems[i];

            // console.log(`[DEBUG] ✓ Coluna encontrada no índice [${i}]`);

            break;
          }
        }
      }

      // Método 2 (Fallback): Procura por texto que contenha "Total" ou apenas valor monetário

      if (!valueElement) {
        allItems.forEach((item, idx) => {
          const text = item.textContent.toLowerCase();

          if (text.includes("total") && text.match(/[\d.,]+\s*€/)) {
            valueElement = item;

            // console.log(
            //   `[DEBUG] ✓ Coluna encontrada por texto "Total" no índice [${idx}]`
            // );
          }
        });
      }

      if (!valueElement) {
        // console.warn(
        //   "[DEBUG] ⚠️ Nenhuma coluna com valor monetário encontrada nesta linha!"
        // );

        return; // Pula esta linha
      }

      const value = parseValue(valueElement);

      count++;

      total = Math.round((total + value) * 100) / 100;
    });

    // console.log(`[DEBUG TOTALS] Count: ${count}, Total: ${total}`);

    return { count, total };
  };

  // --- FUNÇÃO PRINCIPAL DE ATUALIZAÇÃO (Mantida) ---

  const toggleBulkButton = () => {
    const selectedTotals = calculateTotals(true);

    const allTotals = calculateTotals(false);
    const isAnyChecked = Array.from(rowCheckboxes).some((cb) => cb.checked);
    const isAnyCheckedTotals = selectedTotals.count > 0;

    // 1. Lógica dos Botões de Ação

    bulkActionButton?.classList.toggle("d-none", !isAnyChecked);
    bulkActionUsersButton?.classList.toggle("d-none", !isAnyChecked);
    bulkActionDocsButton?.classList.toggle("opacity-0", !isAnyChecked);

    // 2. Lógica da Barra de Resumo (Texto e Valor)

    if (summaryTextCount && summaryTextValue) {
      if (isAnyCheckedTotals) {
        const docText = selectedTotals.count === 1 ? "documento" : "documentos";

        summaryTextCount.textContent = `${selectedTotals.count} ${docText} selecionados para regularizar`;

        summaryTextValue.textContent = formatCurrency(selectedTotals.total);

        summaryBarWrapper?.classList.add("is-active-selection");
      } else {
        const docText = allTotals.count === 1 ? "documento" : "documentos";

        summaryTextCount.textContent = `Total de ${allTotals.count} ${docText} por regularizar`;

        summaryTextValue.textContent = formatCurrency(allTotals.total);

        summaryBarWrapper?.classList.remove("is-active-selection");
      }
    }
  };

  // --- LÓGICA DOS EVENT LISTENERS (Mantida) ---

  rowCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const tableBody = this.closest(".table-body, .card");

      if (tableBody) {
        tableBody.classList.toggle("is-selected", this.checked);
      }

      toggleBulkButton();
    });
  });

  // Adiciona listener para clicar na linha inteira
  dataRows.forEach((row) => {
    row.addEventListener("click", function (e) {
      console.log("[DEBUG] Clicou na linha", e.target);

      // Não ativa se clicou diretamente na checkbox ou num link/botão
      if (
        e.target.classList.contains("form-check-input") ||
        e.target.closest("a") ||
        e.target.closest("button")
      ) {
        console.log(
          "[DEBUG] Clicou num elemento excluído (checkbox/link/botão)",
        );
        return;
      }

      // Para cada linha desktop (.table-body), procura a linha mobile correspondente
      let allCheckboxes = [];

      if (row.classList.contains("table-body")) {
        // É a linha desktop - procura checkboxes nela
        const desktopCheckboxes = row.querySelectorAll(".form-check-input");
        allCheckboxes.push(...desktopCheckboxes);

        // Procura a linha mobile correspondente (índice igual)
        const rowIndex = Array.from(dataRows)
          .filter((r) => r.classList.contains("table-body"))
          .indexOf(row);
        const mobileCards = budgetTable.querySelectorAll(".card.d-xl-none");
        if (mobileCards[rowIndex]) {
          const mobileCheckboxes =
            mobileCards[rowIndex].querySelectorAll(".form-check-input");
          allCheckboxes.push(...mobileCheckboxes);
        }
      } else if (row.classList.contains("card")) {
        // É a linha mobile - procura checkboxes nela
        const mobileCheckboxes = row.querySelectorAll(".form-check-input");
        allCheckboxes.push(...mobileCheckboxes);

        // Procura a linha desktop correspondente (índice igual)
        const rowIndex = Array.from(dataRows)
          .filter((r) => r.classList.contains("card"))
          .indexOf(row);
        const desktopRows = budgetTable.querySelectorAll(
          ".table-body.d-none.d-xl-flex",
        );
        if (desktopRows[rowIndex]) {
          const desktopCheckboxes =
            desktopRows[rowIndex].querySelectorAll(".form-check-input");
          allCheckboxes.push(...desktopCheckboxes);
        }
      }

      console.log(
        "[DEBUG] Checkboxes encontradas (mobile + desktop):",
        allCheckboxes.length,
      );

      if (allCheckboxes.length > 0) {
        // Alterna o estado de TODAS as checkboxes (mobile E desktop)
        const newState = !allCheckboxes[0].checked;
        allCheckboxes.forEach((checkbox) => {
          checkbox.checked = newState;
          console.log("[DEBUG] Checkbox agora está:", checkbox.checked);
        });
        // Dispara o evento 'change' apenas na primeira (evita duplicação de lógica)
        allCheckboxes[0].dispatchEvent(new Event("change"));
      }
    });
  });

  const checkAll = document.querySelector(".table__budgets #check-all");

  if (checkAll) {
    checkAll.addEventListener("change", function () {
      rowCheckboxes.forEach((cb) => {
        if (cb.id !== "check-all") {
          cb.checked = this.checked;

          cb.dispatchEvent(new Event("change"));
        }
      });
    });
  }

  // Inicializa o estado da barra

  toggleBulkButton();
});

const productSliderContainers = document.querySelectorAll(
  ".product-slider-container",
);
if (productSliderContainers) {
  productSliderContainers.forEach((container) => {
    const mainSliderEl = container.querySelector(".product-slider-main");
    const thumbsSliderEl = container.querySelector(
      '[class*="product-slider-thumbs"]',
    );
    let thumbsSwiper = null;

    if (thumbsSliderEl) {
      const isVertical = thumbsSliderEl.classList.contains(
        "product-slider-thumbs-vertical",
      );

      thumbsSwiper = new Swiper(thumbsSliderEl, {
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        direction: isVertical ? "vertical" : "horizontal",
        ...(isVertical && { height: 400 }), // Altura para o slider vertical
      });
    }

    if (mainSliderEl) {
      new Swiper(mainSliderEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: ".pagination-container .swiper-button-next",
          prevEl: ".pagination-container .swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    }
  });
}

// Inicializa sliders normais que não estão dentro de um .product-slider_container
const normalSliders = document.querySelectorAll(
  ".product-slider-main:not(:has(~.product-slider-container *))",
);
if (normalSliders) {
  normalSliders.forEach((sliderEl) => {
    if (!sliderEl.swiper) {
      // Verifica se já não foi inicializado
      new Swiper(sliderEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: sliderEl.querySelector(
            ".pagination-container .swiper-button-next",
          ),
          prevEl: sliderEl.querySelector(
            ".pagination-container .swiper-button-prev",
          ),
        },
        pagination: false,
      });
    }
  });
}

// IMAGES PARALLAX
const parallaxElements = document.querySelectorAll(".parallax-element");
if (parallaxElements) {
  parallaxElements.forEach((element) => {
    const speed = parseFloat(element.dataset.speed) || 1;

    const yPercentMove = (speed - 1) * 200;

    gsap.to(element, {
      yPercent: yPercentMove,
      ease: "none",
      scrollTrigger: {
        trigger: ".images-parallax-container",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });
}

const filterButtons = document.querySelectorAll(
  ".career-filters button[data-category]",
);
const jobCardsHorizontal = document.querySelectorAll(".job-card-horizontal");
const jobCardsVertical = document.querySelectorAll(".job-card-vertical");

if (filterButtons) {
  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const category = this.getAttribute("data-category");

      // Update active button
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      // Filter horizontal jobs
      jobCardsHorizontal.forEach((card) => {
        const jobCategories = card
          .getAttribute("data-job-categories")
          .split(" ");

        if (category === "all" || jobCategories.includes(category)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });

      // Filter vertical jobs
      jobCardsVertical.forEach((card) => {
        const jobCategories = card
          .getAttribute("data-job-categories")
          .split(" ");

        if (category === "all" || jobCategories.includes(category)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
}

const cards = gsap.utils.toArray(".sticky-cards-container .sticky-card");
const cardSpacing = 20;
const deepFromBottom = window.innerHeight * 1.2;
const scrollDuration = 1.2;

if (cards.length > 0) {
  ScrollTrigger.matchMedia({
    "(min-width: 993px)": function () {
      // 1. Define o estado inicial dos cards (A opacidade 1 é aceitável, mas pode causar um flash se o CSS inicial for 0)
      gsap.set(cards, {
        opacity: 1,
        zIndex: (i) => cards.length - i,
      });

      // Torna o primeiro card (índice 0) imediatamente visível e na posição inicial
      gsap.set(cards[0], {
        opacity: 1,
        y: 0,
        scale: 1,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".sticky-cards-section",
          pin: true,
          scrub: 1,
          start: "top top",
          end: () =>
            "+=" + window.innerHeight * (cards.length - 1) * scrollDuration,
        },
      });

      cards.forEach((card, index) => {
        if (index === 0) {
          return;
        }

        // Define o tempo na timeline onde a transição começa
        const startTime = (index - 1) * 0.8;

        // === PASSO CHAVE 1: Z-INDEX E OPACIDADE INSTANTÂNEOS ===
        // O tl.set() aplica as propriedades de forma imediata (não animada)
        tl.set(
          card,
          {
            // Garante a opacidade 1 imediatamente (sem fade in)
            opacity: 1,
            // Garante que o Z-INDEX é o mais alto imediatamente
            zIndex: cards.length + index + 1,
          },
          startTime,
        ); // Aplica no início da transição

        // === ANIMAÇÃO 2: ENTRADA do Cartão Atual (Movimento e Escala) ===
        tl.fromTo(
          card,
          {
            // Estado inicial: Fora do viewport
            y: deepFromBottom,
            scale: 0.9,
            // REMOVER Z-INDEX e OPACITY daqui
          },
          {
            // Estado final: Posição central
            y: 0,
            scale: 1,
            // REMOVER Z-INDEX e OPACITY daqui
            duration: 0.5,
            ease: "power1.out",
          },
          startTime, // Inicia no mesmo ponto
        );

        // === ANIMAÇÃO 3: MOVIMENTO dos Cartões Anteriores (Recuo) ===
        const previousCards = cards.slice(0, index);

        if (previousCards.length > 0) {
          previousCards.forEach((prevCard, i) => {
            const offset = index - i;

            tl.to(
              prevCard,
              {
                y: -cardSpacing * offset,
                scale: 1 - offset * 0.02,
                opacity: 1,
                duration: 0.4,
                ease: "power2.inOut",
              },
              // Inicia ligeiramente após o novo cartão começar a subir
              startTime + 0.1,
            );
          });
        }
      });

      tl.to({}, { duration: 0.5 });
    },

    "(max-width: 992px)": function () {
      // O GSAP reverte as animações
    },
  });
}

const filters = document.querySelectorAll("#doc-filters .btn");
const categories = document.querySelectorAll(".subcategory-group");
if (filters && categories) {
  let activeFilters = ["all"];

  filters.forEach((filter) => {
    filter.addEventListener("click", function () {
      const filterValue = this.dataset.filter;

      if (filterValue === "all") {
        if (!this.classList.contains("active")) {
          activeFilters = ["all"];
          filters.forEach((f) => f.classList.remove("active", "btn-primary"));
          filters.forEach((f) => f.classList.add("btn-outline-primary"));
          this.classList.add("active");
          this.classList.add("btn-primary");
          this.classList.remove("btn-outline-primary");
        }
      } else {
        // Se 'all' estava ativo, remove
        if (activeFilters.includes("all")) {
          const allFilter = document.querySelector(
            '#doc-filters .btn[data-filter="all"]',
          );
          allFilter.classList.remove("active", "btn-primary");
          allFilter.classList.add("btn-outline-primary");
          activeFilters = [];
        }

        // Toggle do filtro atual
        const index = activeFilters.indexOf(filterValue);
        if (index > -1) {
          activeFilters.splice(index, 1);
          this.classList.remove("active", "btn-primary");
          this.classList.add("btn-outline-primary");
        } else {
          activeFilters.push(filterValue);
          this.classList.add("active", "btn-primary");
          this.classList.remove("btn-outline-primary");
        }

        // Se nenhum filtro estiver selecionado, ativa 'all'
        if (activeFilters.length === 0) {
          activeFilters = ["all"];
          const allFilter = document.querySelector(
            '#doc-filters .btn[data-filter="all"]',
          );
          allFilter.classList.add("active", "btn-primary");
          allFilter.classList.remove("btn-outline-primary");
        }
      }

      // Atualiza os botões para o estilo preenchido/contorno
      filters.forEach((f) => {
        if (activeFilters.includes(f.dataset.filter)) {
          f.classList.add("active", "btn-primary");
          f.classList.remove("btn-outline-primary");
        } else {
          f.classList.remove("active", "btn-primary");
          f.classList.add("btn-outline-primary");
        }
      });

      updateCategories();
    });
  });

  function updateCategories() {
    categories.forEach((category) => {
      const categoryName = category.dataset.category;
      if (
        activeFilters.includes("all") ||
        activeFilters.includes(categoryName)
      ) {
        category.style.display = "";
      } else {
        category.style.display = "none";
      }
    });
  }

  // Set initial state for 'View all'
  const allButton = document.querySelector(
    '#doc-filters .btn[data-filter="all"]',
  );
  if (allButton) {
    allButton.classList.add("btn-primary");
    allButton.classList.remove("btn-outline-primary");
  }
}

const pickupTab = document.querySelector("#pick-up-tab");
const chooseStorePane = document.querySelector("#choose-pickup-store");
const selectedStorePane = document.querySelector("#selected-pickup-store");
const saveButton = document.querySelector("#save-and-continue");
const editButton = document.querySelector("#edit-store");
if (pickupTab) {
  saveButton.addEventListener("click", function (event) {
    event.preventDefault();
    chooseStorePane.classList.add("d-none");
    selectedStorePane.classList.remove("d-none");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  editButton.addEventListener("click", function (event) {
    event.preventDefault();
    chooseStorePane.classList.remove("d-none");
    selectedStorePane.classList.add("d-none");
  });
}

const floatingContainer = document.querySelector(".floating-container");
const footer = document.querySelector("footer"); // A referência ao footer continua a ser necessária

if (floatingContainer && footer && typeof ScrollTrigger !== "undefined") {
  ScrollTrigger.matchMedia({
    // Media query para ecrãs maiores que 992px
    "(min-width: 992px)": function () {
      ScrollTrigger.create({
        trigger: floatingContainer,
        pin: true,
        start: "top top",

        // A lógica para o 'end' permanece a mesma
        end: () =>
          "+=" +
          (footer.offsetTop -
            (floatingContainer.offsetTop + floatingContainer.offsetHeight) -
            300),

        pinSpacing: false,

        // markers: true, // Descomente para depuração
      });
    },
  });
}

const btnPesquisaRepresentantes = document.querySelector("#search-btn");
if (btnPesquisaRepresentantes) {
  btnPesquisaRepresentantes.addEventListener("click", function (event) {
    event.preventDefault();
    document.querySelector("#representatives-list").classList.remove("d-none");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

const searchInput = document.querySelector(".search-input");
const navbarBrand = document.querySelector(".navbar-brand");
const navbarToggler = document.querySelector(".navbar-toggler");
const openSearch = document.getElementById("open-search");
const closeSearch = document.querySelector(".close-input-close");

if (searchInput && navbarBrand) {
  function toggleNavbarBrand(isSearchVisible) {
    if (isSearchVisible && window.innerWidth < 1200) {
      navbarBrand.classList.add("d-none");
      navbarToggler.classList.add("d-none");
    } else {
      navbarBrand.classList.remove("d-none");
      navbarToggler.classList.remove("d-none");
    }
  }

  // Fallback with MutationObserver for robustness
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        const isSearchVisible = mutation.target.classList.contains("show");
        toggleNavbarBrand(isSearchVisible);
      }
    });
  });

  if (searchInput) {
    observer.observe(searchInput, {
      attributes: true,
    });
  }
}

const menuMobile = document.querySelector(".main-menu__mobile");

if (menuMobile) {
  const headerActions = document.querySelector(".header-actions");
  const navbarToggler = document.querySelector(".navbar-toggler");
  // Seletor mais específico para o dropdown de línguas dentro da label mobile
  const languageSelector = document.querySelector(
    ".menu-mobile-label__container .dropdown",
  );

  // 1. Garantir que começa escondido
  if (languageSelector) languageSelector.classList.add("d-none");

  if (navbarToggler) {
    menuMobile.addEventListener("show.bs.collapse", function (e) {
      if (e.target !== menuMobile) return;
      if (headerActions) headerActions.classList.add("d-none");
      if (languageSelector) languageSelector.classList.remove("d-none");
    });

    menuMobile.addEventListener("hide.bs.collapse", function (e) {
      if (e.target !== menuMobile) return;
      if (headerActions) headerActions.classList.remove("d-none");
      if (languageSelector) languageSelector.classList.add("d-none");
    });
  }
}

const banner = document.querySelector(".banner--home");
if (banner) {
  const contentLayer = banner.querySelector(
    ".banner__content--layer__white .bg-white",
  );
  const paginationWrapper = banner.querySelector(".pagination__wrapper");

  if (contentLayer && paginationWrapper) {
    const updatePaginationPosition = () => {
      if (window.innerWidth < 992) {
        const contentHeight = contentLayer.offsetHeight;
        paginationWrapper.style.bottom = `${contentHeight + 15}px`;
      } else {
        paginationWrapper.style.bottom = ""; // Reseta o estilo para ecrãs maiores
      }
    };

    // Run on initial load
    updatePaginationPosition();

    // Run on window resize
    window.addEventListener("resize", updatePaginationPosition);

    // Also run after swiper initializes, in case of any delays
    const swiperInstance = banner.querySelector(".swiper-from-dataset").swiper;
    if (swiperInstance) {
      swiperInstance.on("init resize", updatePaginationPosition);
    } else {
      // Fallback if swiper is not ready yet
      setTimeout(updatePaginationPosition, 500);
    }
  }
}

$(".ar__select").each(function () {
  var $select = $(this);

  $select.on("select2:open", function (e) {
    // Usamos setTimeout(0) para dar tempo ao dropdown de ser renderizado
    // antes de fazermos os cálculos.
    setTimeout(function () {
      try {
        // 1. Encontra o 'pai' (o div.custom-select-option)
        var $wrapper = $select.closest(".custom-select-option");
        if (!$wrapper.length) {
          $wrapper = $select.parent(); // Fallback
        }

        // 2. Encontra o elemento <span> do select2 (o select visível)
        var $span = $select.siblings(".select2-container");

        // 3. Encontra o dropdown que abriu (o .select2-dropdown)
        var $dropdown = $select.data("select2").$dropdown;

        // 4. Mede a largura do 'pai'
        var wrapperWidth = $wrapper.outerWidth();

        // 5. Mede as posições 'left' relativas ao DOCUMENTO
        var wrapperOffset = $wrapper.offset().left;
        var spanOffset = $span.offset().left; // Posição atual do dropdown

        // 6. Calcula a margem necessária para alinhar o dropdown
        //    com a borda esquerda do 'pai' (wrapper)
        var marginValue = wrapperOffset - spanOffset;

        // 7. Aplica o CSS ao dropdown
        $dropdown.css({
          width: wrapperWidth + "px", // Define a largura
          "margin-left": marginValue + "px", // Alinha à esquerda
        });
      } catch (error) {
        console.error("Erro ao ajustar o dropdown do Select2:", error);
      }
    }, 0); // O '0' é a parte importante
  });
});

const highlightSwitch = document.getElementById("highlight-differences");
if (highlightSwitch) {
  highlightSwitch.addEventListener("change", function () {
    const productColumns = document.querySelectorAll(
      ".comparator-section .col-lg-4",
    );
    if (productColumns.length < 2) return;

    const allSpecItems = document.querySelectorAll(
      ".comparator-section .specifications-container li",
    );
    allSpecItems.forEach((item) => {
      item.classList.remove("text-primary");
    });

    if (this.checked) {
      const specGroupsByProduct = [];
      productColumns.forEach((column) => {
        specGroupsByProduct.push(
          column.querySelectorAll(".specifications-container > div"),
        );
      });

      const numSpecGroups = specGroupsByProduct[0].length;

      for (let i = 0; i < numSpecGroups; i++) {
        const numItemsInGroup =
          specGroupsByProduct[0][i].querySelectorAll("li").length;

        for (let j = 0; j < numItemsInGroup; j++) {
          const itemsToCompare = [];
          let firstValue = null;
          let isDifferent = false;

          specGroupsByProduct.forEach((productGroups, productIndex) => {
            const item = productGroups[i].querySelectorAll("li")[j];
            const valueSpan = item.querySelectorAll("span")[1];
            const value = valueSpan ? valueSpan.textContent.trim() : "";

            itemsToCompare.push(item);

            if (productIndex === 0) {
              firstValue = value;
            } else {
              if (value !== firstValue) {
                isDifferent = true;
              }
            }
          });

          if (isDifferent) {
            itemsToCompare.forEach((item) => {
              item.classList.add("text-primary");
            });
          }
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  let mm = gsap.matchMedia();

  const track = document.querySelector(".timeline-track");
  if (track) {
    const wrapper = document.querySelector(".timeline-wrapper");
    const progressContainer = document.querySelector(".progress-container");
    const fillLine = document.querySelector(".fill-line");
    const cards = document.querySelectorAll(".timeline-card");

    // Cache para posições que não mudam frequentemente
    let cachedLineStartPos = 0;
    let cachedDotPositions = [];

    // Atualiza o cache de posições (chama no resize e na inicialização)
    function updatePositionCache() {
      cachedLineStartPos = progressContainer.getBoundingClientRect().left;
      cachedDotPositions = Array.from(cards).map((card) => {
        const dot = card.querySelector(".year-dot");
        const dotRect = dot.getBoundingClientRect();
        return {
          dot: dot,
          position: dotRect.left - cachedLineStartPos - 10 // offset aplicado aqui
        };
      });
    }

    // Função auxiliar para verificar colisão (usada em Desktop e Mobile)
    // Otimizada para reduzir forced reflows
    function checkDotCollision() {
      // 1. Lê o tamanho da linha azul apenas uma vez
      const currentLineLength = fillLine.getBoundingClientRect().width;

      // 2. Usa posições cacheadas dos dots
      cachedDotPositions.forEach(({ dot, position }) => {
        if (currentLineLength >= position) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }

    // =====================================================
    // DESKTOP (GSAP)
    // =====================================================
    mm.add("(min-width: 992px)", () => {
      // Limpezas
      progressContainer.style.width = "";

      // Atualiza cache de posições
      updatePositionCache();

      let totalWidth = track.scrollWidth;
      let viewportWidth = window.innerWidth;

      // O valor exato que o track tem de andar para a esquerda
      // Aumentei a margem (+200) para garantir que se vê o último slide bem
      let amountToScroll = totalWidth - viewportWidth + 200;

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: "center center",
          end: "+=" + amountToScroll,
          pin: true,
          scrub: 0.5, // Um pouco de suavidade ajuda a ver a cor a mudar
          invalidateOnRefresh: true,
          onRefresh: updatePositionCache, // Atualiza cache ao fazer refresh do ScrollTrigger
        },
        // O SEGREDO: Executa esta função sempre que a animação atualiza
        onUpdate: checkDotCollision,
      });

      // Move o conteúdo
      tl.to(track, { x: -amountToScroll, ease: "none" }, 0);

      // Enche a barra
      tl.to(fillLine, { width: "100%", ease: "none" }, 0);
    });

    // =====================================================
    // MOBILE (JS Nativo)
    // =====================================================
    mm.add("(max-width: 991px)", () => {
      function setupMobile() {
        // Em mobile, a linha cinzenta tem de ser do tamanho do scroll total
        progressContainer.style.width = track.scrollWidth - 20 + "px";
        // Atualiza cache de posições quando o setup é chamado
        updatePositionCache();
      }

      function updateMobile() {
        let scrollLeft = wrapper.scrollLeft;
        let maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

        // Evita erros se não houver scroll
        if (maxScroll <= 0) return;

        let percentage = scrollLeft / maxScroll;
        fillLine.style.width = percentage * 100 + "%";

        // Chama a mesma função de colisão otimizada
        checkDotCollision();
      }

      setupMobile();
      wrapper.addEventListener("scroll", updateMobile);
      
      // Atualiza cache no resize
      const handleResize = () => {
        setupMobile();
        updateMobile();
      };
      window.addEventListener("resize", handleResize);

      return () => {
        wrapper.removeEventListener("scroll", updateMobile);
        window.removeEventListener("resize", handleResize);
        progressContainer.style.width = "";
        fillLine.style.width = "";
        cards.forEach((c) =>
          c.querySelector(".year-dot").classList.remove("active"),
        );
      };
    });
  }
});

// Usando jQuery para ser compatível com muitos temas Bootstrap
$("header .dropdown")
  .on("mouseenter", function () {
    // Encontra o dropdown-toggle dentro deste li e simula o clique para abrir o menu
    $(this).find(".dropdown-menu").addClass("show");
  })
  .on("mouseleave", function () {
    // Encontra o dropdown-menu e remove a classe 'show' para fechar
    $(this).find(".dropdown-menu").removeClass("show");
  });

// Se quiser garantir que a navegação do link principal funciona mesmo assim (opcional, mas seguro):
$("header .dropdown > a").on("click", function () {
  window.location = $(this).attr("href");
});

// Toggle billing address form
const billingCheckbox = document.querySelector(
  'input[name="address_faturacao"]',
);
const billingDisplay = document.getElementById("billing-address-display");
const billingForm = document.getElementById("billing-address-form");

if (billingCheckbox && billingDisplay && billingForm) {
  billingCheckbox.addEventListener("change", function () {
    if (this.checked) {
      billingDisplay.classList.remove("d-none");
      billingForm.classList.add("d-none");
    } else {
      billingDisplay.classList.add("d-none");
      billingForm.classList.remove("d-none");
    }
  });
}

(function () {
  const banner = document.querySelector(".banner--home");
  if (!banner) return;

  const header = document.querySelector(".header");
  const headerHeight = header ? header.offsetHeight : 0;

  function updateOverBanner() {
    const bannerBottom = banner.offsetTop + banner.offsetHeight;
    if (window.scrollY < bannerBottom - headerHeight) {
      document.body.classList.add("over-banner");
    } else {
      document.body.classList.remove("over-banner");
    }
  }

  updateOverBanner();
  window.addEventListener("scroll", updateOverBanner, { passive: true });
  window.addEventListener("resize", updateOverBanner, { passive: true });
})();

// Toggle billing address form B2C
const billingCheckboxB2C = document.querySelector(
  'input[name="morada_envio_checkout"]',
);
const billingDisplayB2C = document.getElementById(
  "billing-address-display-b2c",
);
const billingFormB2C = document.getElementById("billing-address-form-b2c");

if (billingCheckboxB2C && billingDisplayB2C && billingFormB2C) {
  billingCheckboxB2C.addEventListener("change", function () {
    if (this.checked) {
      billingDisplayB2C.classList.remove("d-none");
      billingFormB2C.classList.add("d-none");
    } else {
      billingDisplayB2C.classList.add("d-none");
      billingFormB2C.classList.remove("d-none");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const tabContainer = document.querySelector("#myTab");
  if (tabContainer) {
    const tabs = tabContainer.querySelectorAll('[data-bs-toggle="tab"]');

    tabs.forEach((tab) => {
      tab.addEventListener("click", function (e) {
        // 1. Obter a largura do contentor (a parte visível do telemóvel)
        const containerWidth = tabContainer.offsetWidth;

        // 2. Obter a posição do botão clicado (distância da esquerda)
        const tabLeft = e.target.offsetLeft;

        // 3. Obter a largura do botão clicado
        const tabWidth = e.target.offsetWidth;

        // 4. Calcular a posição de scroll para deixar o botão no centro:
        // (Posição do botão) - (Metade do ecrã) + (Metade do botão)
        const scrollPos = tabLeft - containerWidth / 2 + tabWidth / 2;

        // 5. Aplicar o scroll suavemente
        tabContainer.scrollTo({
          left: scrollPos,
          behavior: "smooth",
        });
      });
    });
  }
});

const productCards = document.querySelectorAll(".product-card");
if (productCards.length > 0) {
  productCards.forEach((card) => {
    const mainImage = card.querySelector(".product-main-image");
    const colorSwatches = card.querySelectorAll(".color-swatch[data-image]");

    if (!mainImage || colorSwatches.length === 0) return;

    // Store original image source
    const originalImageSrc = mainImage.src;

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        const newImageSrc = this.getAttribute("data-image");
        if (newImageSrc) {
          mainImage.src = newImageSrc;
        }
      });

      swatch.addEventListener("mouseleave", function () {
        mainImage.src = originalImageSrc;
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const colorOptions = document.querySelectorAll(".color-option");
  const customColorPicker = document.getElementById("customColorPicker");
  const colorHexInput = document.getElementById("colorHexInput");
  const changeColorElement = document.querySelector(".change-color");

  // Só executa se os elementos existirem na página
  if (!colorOptions.length && !customColorPicker && !colorHexInput) {
    return;
  }

  // Função para atualizar a cor
  function updateColor(color) {
    if (changeColorElement) {
      changeColorElement.style.backgroundColor = color;
    }

    // Atualiza o input hex
    if (colorHexInput) {
      colorHexInput.value = color.toUpperCase();
    }

    // Atualiza o color picker personalizado
    if (customColorPicker) {
      customColorPicker.value = color;
    }

    // Remove classe active de todos os botões
    colorOptions.forEach((btn) => {
      btn.classList.remove("active");
    });
  }

  // Adiciona event listener para cada opção de cor
  colorOptions.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedColor = this.getAttribute("data-color");
      updateColor(selectedColor);

      // Marca o botão como selecionado
      this.classList.add("active");
    });
  });

  // Event listener para o color picker personalizado
  if (customColorPicker) {
    customColorPicker.addEventListener("input", function () {
      updateColor(this.value);
    });
  }

  // Event listener para o input hex
  if (colorHexInput) {
    colorHexInput.addEventListener("input", function () {
      let hexValue = this.value;

      // Adiciona # se não existir
      if (hexValue && !hexValue.startsWith("#")) {
        hexValue = "#" + hexValue;
        this.value = hexValue;
      }

      // Valida se é um hex válido (3 ou 6 caracteres após o #)
      if (
        /^#[0-9A-Fa-f]{6}$/.test(hexValue) ||
        /^#[0-9A-Fa-f]{3}$/.test(hexValue)
      ) {
        updateColor(hexValue);
      }
    });

    // Abre o color picker ao clicar no input hex
    colorHexInput.addEventListener("click", function () {
      if (customColorPicker) {
        customColorPicker.click();
      }
    });
  }

  // Também ao clicar no botão
  const openPickerBtn = document.getElementById("openColorPicker");
  if (openPickerBtn) {
    openPickerBtn.addEventListener("click", function () {
      if (customColorPicker) {
        customColorPicker.click();
      }
    });
  }

  // Seleciona a primeira cor por padrão
  if (colorOptions.length > 0) {
    colorOptions[0].classList.add("active");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const categoryItems = document.querySelectorAll(".category-item");
  const selectedContainer = document.querySelector(".all-selected-categories");
  const basePath = window.BASE_PATH || "";

  // console.log("Category items found:", categoryItems.length);
  // console.log("Selected container:", selectedContainer);

  // Função para sincronizar estado entre desktop e mobile
  function syncCategoryState(categoryName, isSelected) {
    // Encontrar todos os itens com o mesmo data-category (desktop + mobile)
    const allMatchingItems = document.querySelectorAll(
      `.category-item[data-category="${categoryName}"]`,
    );

    allMatchingItems.forEach((item) => {
      const iconUse = item.querySelector(".category-icon use");
      if (iconUse) {
        if (isSelected) {
          iconUse.setAttribute(
            "xlink:href",
            basePath + "/assets/icomoon/symbol-defs.svg#icon-check",
          );
          item.classList.add("selected");
        } else {
          iconUse.setAttribute(
            "xlink:href",
            basePath + "/assets/icomoon/symbol-defs.svg#icon-plus",
          );
          item.classList.remove("selected");
        }
      }
    });
  }

  if (categoryItems.length && selectedContainer) {
    categoryItems.forEach((item) => {
      item.addEventListener("click", function () {
        const categoryName = this.getAttribute("data-category");
        const iconUse = this.querySelector(".category-icon use");
        const parentCategory = this.closest(".accordion-item");
        const parentCategoryId = parentCategory
          ? parentCategory.querySelector(".accordion-button").textContent.trim()
          : "";
        console.log("Clicked category:", categoryName);

        // Verificar se já foi adicionada
        const existingCategory = selectedContainer.querySelector(
          `[data-category="${categoryName}"]`,
        );

        if (existingCategory) {
          // Se já existe, remover
          console.log("Removing category");
          const parentCatId = existingCategory.getAttribute(
            "data-parent-category",
          );
          existingCategory.remove();

          // Sincronizar estado entre desktop e mobile
          syncCategoryState(categoryName, false);

          // Atualizar botão de categoria completa
          updateAddCompleteCategoryButton(parentCatId);
          return;
        }

        // Sincronizar estado entre desktop e mobile
        syncCategoryState(categoryName, true);

        // Criar badge da categoria selecionada
        const badge = document.createElement("div");
        badge.className =
          "d-inline-flex align-items-center gap-2 badge bg-primary text-white rounded-pill px-3 py-2 me-2 mb-2 position-relative";
        badge.setAttribute("data-category", categoryName);
        badge.setAttribute("data-parent-category", parentCategoryId);
        badge.innerHTML = `          
          <button type="button" class="btn p-0 border-0 bg-transparent text-white category-dots-btn" aria-label="Opções">
            <svg class="icon icon-dots">
              <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-dots"></use>
            </svg>
          </button>
          <span>${categoryName}</span>
          <div class="category-tooltip bg-white rounded shadow-sm border d-none">
            <button type="button" class="btn btn-sm text-start w-100 show-only-category">
              <svg class="icon icon-view me-2">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-view"></use>
              </svg>
              Mostrar só esta Sub-categoria
            </button>
            <button type="button" class="btn btn-sm text-start w-100 remove-category">
              <svg class="icon icon-trash me-2">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-trash"></use>
              </svg>
              Remover Sub-categoria
            </button>
          </div>
        `;

        // Adicionar evento para o botão de três pontos
        const dotsBtn = badge.querySelector(".category-dots-btn");
        const tooltip = badge.querySelector(".category-tooltip");

        dotsBtn.addEventListener("click", function (e) {
          e.stopPropagation();

          // Fechar todos os outros tooltips
          document.querySelectorAll(".category-tooltip").forEach((t) => {
            if (t !== tooltip) {
              t.classList.add("d-none");
            }
          });

          const isHidden = tooltip.classList.contains("d-none");
          tooltip.classList.toggle("d-none");

          // Posicionar tooltip com position fixed
          if (isHidden) {
            const badgeRect = badge.getBoundingClientRect();
            tooltip.style.top = `${badgeRect.bottom + 5}px`;
            tooltip.style.left = `${badgeRect.left + badgeRect.width / 2}px`;
          }
        });

        // Fechar tooltip ao clicar fora
        document.addEventListener("click", function (e) {
          if (!badge.contains(e.target)) {
            tooltip.classList.add("d-none");
          }
        });

        // Evento "Mostrar só esta"
        const showOnlyBtn = badge.querySelector(".show-only-category");
        const showOnlyBtnIcon = showOnlyBtn.querySelector(".icon use");
        const showOnlyBtnText = showOnlyBtn.childNodes[2]; // O texto depois do SVG
        let isFiltered = false;

        showOnlyBtn.addEventListener("click", function () {
          tooltip.classList.add("d-none");

          // Obtém a categoria pai do badge atual
          const currentParentCategory = badge.getAttribute(
            "data-parent-category",
          );

          // Filtra apenas badges da mesma categoria pai
          const allBadges = selectedContainer.querySelectorAll(".badge");

          if (!isFiltered) {
            // Ativar filtro
            console.log("Mostrar só:", categoryName);

            allBadges.forEach((b) => {
              const bParentCategory = b.getAttribute("data-parent-category");
              const bDotsIcon = b.querySelector(".category-dots-btn .icon use");

              // Só aplica muted se for da mesma categoria pai
              if (b !== badge && bParentCategory === currentParentCategory) {
                b.classList.add("badge-muted");
                // Trocar ícone para disabled
                if (bDotsIcon) {
                  bDotsIcon.setAttribute(
                    "xlink:href",
                    basePath + "/assets/icomoon/symbol-defs.svg#icon-disabled",
                  );
                }
              } else if (b === badge) {
                b.classList.remove("badge-muted");
                // Manter ícone de dots
                if (bDotsIcon) {
                  bDotsIcon.setAttribute(
                    "xlink:href",
                    basePath + "/assets/icomoon/symbol-defs.svg#icon-dots",
                  );
                }
              }
            });

            // Mudar texto e ícone do botão
            showOnlyBtnText.textContent = " Remover filtro da Sub-categoria";
            showOnlyBtnIcon.setAttribute(
              "xlink:href",
              basePath + "/assets/icomoon/symbol-defs.svg#icon-view",
            );
            isFiltered = true;
          } else {
            // Remover filtro
            console.log("Remover filtro de:", categoryName);

            allBadges.forEach((b) => {
              const bParentCategory = b.getAttribute("data-parent-category");
              const bDotsIcon = b.querySelector(".category-dots-btn .icon use");

              // Remove muted de badges da mesma categoria pai
              if (bParentCategory === currentParentCategory) {
                b.classList.remove("badge-muted");
                // Voltar ícone para dots
                if (bDotsIcon) {
                  bDotsIcon.setAttribute(
                    "xlink:href",
                    basePath + "/assets/icomoon/symbol-defs.svg#icon-dots",
                  );
                }
              }
            });

            // Voltar texto e ícone do botão
            showOnlyBtnText.textContent = " Mostrar só esta Sub-categoria";
            showOnlyBtnIcon.setAttribute(
              "xlink:href",
              basePath + "/assets/icomoon/symbol-defs.svg#icon-view",
            );
            isFiltered = false;
          }
        });

        // Evento "Remover"
        const removeBtn = badge.querySelector(".remove-category");
        removeBtn.addEventListener("click", function () {
          const categoryToRemove = badge.getAttribute("data-category");
          badge.remove();
          tooltip.classList.add("d-none");

          // Sincronizar estado entre desktop e mobile
          syncCategoryState(categoryToRemove, false);
        });

        selectedContainer.appendChild(badge);
        console.log("Badge added to container");

        // Mostrar lista de produtos quando primeira categoria for adicionada
        const productsListContainer = document.querySelector(
          ".products-list-container",
        );
        if (productsListContainer) {
          productsListContainer.classList.remove("d-none");
        }

        // Atualizar contador e botão "Mostrar todas"
        updateCategoryDisplay();

        // Atualizar botão "Adicionar categoria completa"
        updateAddCompleteCategoryButton(parentCategoryId);
      });

      // Suporte para teclado
      item.addEventListener("keypress", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  // Função para gerenciar exibição de categorias (2 linhas max)
  function updateCategoryDisplay() {
    if (!selectedContainer) return;

    const badges = selectedContainer.querySelectorAll(".badge");
    const totalBadges = badges.length;

    // Criar ou atualizar elementos de controle
    let counterWrapper = document.querySelector(".category-counter-wrapper");

    if (!counterWrapper && totalBadges > 0) {
      counterWrapper = document.createElement("div");
      counterWrapper.className =
        "category-counter-wrapper d-flex align-items-center gap-5 m-3";
      counterWrapper.innerHTML = `
        <span class="category-counter text-muted small"></span>
        <button type="button" class="btn btn-link text-primary text-decoration-none p-0 category-toggle-btn d-none">
          <span class="toggle-text">Mostrar todas</span>
          <svg class="icon icon-arrow-down ms-1" style="width: 16px; height: 16px;">
            <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-arrow-down"></use>
          </svg>
        </button>
      `;
      selectedContainer.after(counterWrapper);

      // Adicionar evento ao botão
      const toggleBtn = counterWrapper.querySelector(".category-toggle-btn");
      const toggleText = toggleBtn.querySelector(".toggle-text");
      const toggleIcon = toggleBtn.querySelector(".icon use");

      toggleBtn.addEventListener("click", function () {
        selectedContainer.classList.toggle("expanded");
        const isExpanded = selectedContainer.classList.contains("expanded");

        toggleText.textContent = isExpanded ? "Mostrar menos" : "Mostrar todas";
        const iconElement = toggleBtn.querySelector(".icon");
        if (iconElement) {
          iconElement.classList.toggle("rotate-180", isExpanded);
        }
      });
    }

    // Atualizar contador
    const counter = document.querySelector(".category-counter");
    const toggleBtn = document.querySelector(".category-toggle-btn");

    if (counter) {
      counter.textContent = `${totalBadges} sub-categoria${totalBadges !== 1 ? "s" : ""} adicionada${totalBadges !== 1 ? "s" : ""}`;
    }

    // Mostrar/ocultar botão baseado na altura
    if (toggleBtn && selectedContainer) {
      // Temporariamente expandir para medir altura real
      const wasExpanded = selectedContainer.classList.contains("expanded");
      selectedContainer.classList.add("expanded");
      const fullHeight = selectedContainer.scrollHeight;
      if (!wasExpanded) {
        selectedContainer.classList.remove("expanded");
      }

      // Obter max-height definido no CSS (muda entre desktop e mobile)
      const computedStyle = window.getComputedStyle(selectedContainer);
      const maxHeight = parseInt(computedStyle.maxHeight);

      // Se altura exceder o max-height do CSS, mostrar botão
      if (fullHeight > maxHeight) {
        toggleBtn.classList.remove("d-none");
      } else {
        toggleBtn.classList.add("d-none");
        selectedContainer.classList.remove("expanded");
      }
    }

    // Remover wrapper se não houver badges
    if (totalBadges === 0 && counterWrapper) {
      counterWrapper.remove();

      // Esconder lista de produtos quando não há categorias selecionadas
      const productsListContainer = document.querySelector(
        ".products-list-container",
      );
      if (productsListContainer) {
        productsListContainer.classList.add("d-none");
      }
    }
  }

  // Atualizar display quando remover badge
  const observer = new MutationObserver(updateCategoryDisplay);
  if (selectedContainer) {
    observer.observe(selectedContainer, { childList: true });
  }

  // Função para atualizar botão "Adicionar categoria completa"
  function updateAddCompleteCategoryButton(parentCategoryName) {
    if (!parentCategoryName || !selectedContainer) return;

    // Criar ou obter container de botões completos
    let completeButtonsContainer =
      selectedContainer.parentElement.querySelector(
        ".complete-categories-buttons",
      );
    if (!completeButtonsContainer) {
      completeButtonsContainer = document.createElement("div");
      completeButtonsContainer.className =
        "complete-categories-buttons d-flex flex-wrap gap-2 mb-3";
      selectedContainer.parentElement.insertBefore(
        completeButtonsContainer,
        selectedContainer,
      );
    }

    const buttonId = `add-complete-${parentCategoryName.replace(/\s+/g, "-").toLowerCase()}`;
    let completeButton = document.getElementById(buttonId);

    // Encontrar todas as subcategorias desta categoria pai
    const allSubcategories = Array.from(categoryItems).filter((item) => {
      const parent = item.closest(".accordion-item");
      const parentName = parent
        ? parent.querySelector(".accordion-button").textContent.trim()
        : "";
      return parentName === parentCategoryName;
    });

    // Contar quantas já estão selecionadas
    const selectedSubcategories = Array.from(
      selectedContainer.querySelectorAll(".badge"),
    ).filter((badge) => {
      return badge.getAttribute("data-parent-category") === parentCategoryName;
    });

    const totalSubcategories = allSubcategories.length;
    const selectedCount = selectedSubcategories.length;
    const hasUnselected =
      selectedCount > 0 && selectedCount < totalSubcategories;

    // Criar ou remover botão baseado no estado
    if (hasUnselected && !completeButton) {
      // Criar botão
      completeButton = document.createElement("button");
      completeButton.type = "button";
      completeButton.id = buttonId;
      completeButton.className =
        "btn btn-outline-primary rounded-pill px-3 py-2 me-2 mb-2 add-complete-category-btn";
      completeButton.setAttribute("data-parent-category", parentCategoryName);
      completeButton.innerHTML = `
        <svg class="icon icon-plus me-1" style="width: 14px; height: 14px;">
          <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-plus"></use>
        </svg>
        Adicionar ${parentCategoryName} completa
      `;

      // Adicionar evento de clique
      completeButton.addEventListener("click", function () {
        const parentCat = this.getAttribute("data-parent-category");

        // Adicionar todas as subcategorias não selecionadas
        allSubcategories.forEach((item) => {
          const categoryName = item.getAttribute("data-category");
          const existingBadge = selectedContainer.querySelector(
            `[data-category="${categoryName}"]`,
          );

          if (!existingBadge) {
            // Simular clique no item para adicioná-lo
            item.click();
          }
        });

        // Remover o botão após adicionar todas
        this.remove();

        // Remover container se não houver mais botões
        const container = document.querySelector(
          ".complete-categories-buttons",
        );
        if (container && container.children.length === 0) {
          container.remove();
        }
      });

      // Inserir o botão no container de botões completos
      completeButtonsContainer.appendChild(completeButton);
    } else if (!hasUnselected && completeButton) {
      // Remover botão se todas estão selecionadas ou nenhuma está
      completeButton.remove();

      // Remover container se não houver mais botões
      const container = document.querySelector(".complete-categories-buttons");
      if (container && container.children.length === 0) {
        container.remove();
      }
    }
  }
});

// Toggle botões adicionar produto ao catálogo
document.addEventListener("DOMContentLoaded", function () {
  const productButtons = document.querySelectorAll(".product-add-btn");
  const basePath = window.BASE_PATH || "";

  productButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const iconElement = this.querySelector(".icon use");
      const textElement = this.querySelector("span");
      const isAdded = this.classList.contains("btn-primary");

      if (isAdded) {
        // Remover - voltar para preto
        this.classList.remove("btn-primary", "btn-outline-primary");
        this.classList.add("btn-dark", "btn-outline-dark");

        if (iconElement) {
          iconElement.setAttribute(
            "xlink:href",
            basePath + "/assets/icomoon/symbol-defs.svg#icon-plus",
          );
        }

        if (textElement) {
          textElement.textContent = "Adicionar ao catálogo";
        }
      } else {
        // Adicionar - mudar para azul
        this.classList.remove("btn-dark", "btn-outline-dark");
        this.classList.add("btn-primary", "btn-outline-primary");

        if (iconElement) {
          iconElement.setAttribute(
            "xlink:href",
            basePath + "/assets/icomoon/symbol-defs.svg#icon-check",
          );
        }

        if (textElement) {
          textElement.textContent = "Adicionado ao catálogo";
        }
      }
    });
  });
});

// Scroll automático para o último step ativo em mobile
document.addEventListener("DOMContentLoaded", function () {
  const stepsContainer = document.querySelector(".steps-done");

  if (stepsContainer) {
    function scrollToLastActiveStep() {
      const activeSteps = stepsContainer.querySelectorAll(
        ".catalog-step.active",
      );
      if (activeSteps.length > 0) {
        const lastActiveStep = activeSteps[activeSteps.length - 1];
        const stepParent = lastActiveStep.parentElement;

        // Calcular posição para centralizar o último elemento ativo
        const containerWidth = stepsContainer.offsetWidth;
        const stepLeft = stepParent.offsetLeft;
        const stepWidth = stepParent.offsetWidth;

        // Scroll para centralizar o elemento
        const scrollPosition = stepLeft - containerWidth / 2 + stepWidth / 2;

        stepsContainer.scrollTo({
          left: Math.max(0, scrollPosition),
          behavior: "smooth",
        });
      }
    }

    // Executar ao carregar
    scrollToLastActiveStep();

    // Executar ao redimensionar janela
    window.addEventListener("resize", scrollToLastActiveStep);
  }
});

// Controlar estado do switch "IVA nos preços" baseado no "Mostrar preços"
document.addEventListener("DOMContentLoaded", function () {
  const showPricesSwitch = document.getElementById("show-prices");
  const ivaSwitch = document.getElementById("iva-nos-precos");
  const ivaSwitchContainer = ivaSwitch ? ivaSwitch.closest(".border") : null;

  function updateIvaState() {
    if (showPricesSwitch && ivaSwitch) {
      if (!showPricesSwitch.checked) {
        // Desativar IVA quando "Mostrar preços" estiver desativado
        ivaSwitch.disabled = true;
        ivaSwitch.checked = false;
        if (ivaSwitchContainer) {
          ivaSwitchContainer.style.opacity = "0.5";
          ivaSwitchContainer.style.pointerEvents = "none";
        }
      } else {
        // Ativar IVA quando "Mostrar preços" estiver ativado
        ivaSwitch.disabled = false;
        if (ivaSwitchContainer) {
          ivaSwitchContainer.style.opacity = "1";
          ivaSwitchContainer.style.pointerEvents = "auto";
        }
      }
    }
  }

  // Executar ao carregar a página
  updateIvaState();

  // Executar quando o switch "Mostrar preços" mudar
  if (showPricesSwitch) {
    showPricesSwitch.addEventListener("change", updateIvaState);
  }
});

// Preview em tempo real da contra-capa do catálogo
document.addEventListener("DOMContentLoaded", function () {
  const phoneInput = document.getElementById("contacto_telefonico");
  const emailInput = document.getElementById("email");
  const infoTextarea = document.getElementById("informacoes_adicionais");
  const termsTextarea = document.getElementById("termos_condicoes");

  const phonePreview = document.getElementById("preview-phone");
  const emailPreview = document.getElementById("preview-email");
  const infoPreview = document.getElementById("preview-info");
  const termsPreview = document.getElementById("preview-terms");

  if (phoneInput && phonePreview) {
    phoneInput.addEventListener("input", function () {
      phonePreview.textContent = this.value || "";
    });
  }

  if (emailInput && emailPreview) {
    emailInput.addEventListener("input", function () {
      emailPreview.textContent = this.value || "";
    });
  }

  if (infoTextarea && infoPreview) {
    infoTextarea.addEventListener("input", function () {
      infoPreview.textContent = this.value || "";
    });
  }

  if (termsTextarea && termsPreview) {
    termsTextarea.addEventListener("input", function () {
      termsPreview.textContent = this.value || "";
    });
  }
});

// Toggle brand-hidden elements baseado no radio button catalog_type
document.addEventListener("DOMContentLoaded", function () {
  const radioButtons = document.querySelectorAll('input[name="catalog_type"]');
  const brandHiddenElements = document.querySelectorAll(".brand-hidden");

  if (radioButtons.length === 0 || brandHiddenElements.length === 0) {
    return; // Não existe na página atual
  }

  console.log("Radio buttons encontrados:", radioButtons.length);
  console.log(
    "Elementos .brand-hidden encontrados:",
    brandHiddenElements.length,
  );

  function toggleBrandHidden() {
    const checkedRadio = document.querySelector(
      'input[name="catalog_type"]:checked',
    );
    console.log(
      "Radio selecionado:",
      checkedRadio ? checkedRadio.value : "nenhum",
    );

    if (checkedRadio && checkedRadio.value === "brand-website") {
      console.log("Escondendo elementos .brand-hidden");
      brandHiddenElements.forEach((el) => el.classList.add("d-none"));
    } else {
      console.log("Mostrando elementos .brand-hidden");
      brandHiddenElements.forEach((el) => el.classList.remove("d-none"));
    }
  }

  radioButtons.forEach((radio) => {
    radio.addEventListener("change", toggleBrandHidden);
  });

  // Executar na inicialização
  toggleBrandHidden();
});

// Adicionar produtos da lista ao orçamento
document.addEventListener("DOMContentLoaded", function () {
  const productsTable = document.querySelector(".table__products-list");
  const budgetTable = document.querySelector(".table__budgets-edit");

  if (!productsTable || !budgetTable) {
    return; // Não existe na página atual
  }

  // Função para criar uma nova linha no orçamento
  function createBudgetRow(productData) {
    const basePath = window.BASE_PATH || "";
    const rowId = `budget-row-${Date.now()}`;

    const rowHTML = `
      <div class="table-body position-relative border border-light rounded-2 p-3 mb-3" data-row-id="${rowId}">
        <div class="table-item" data-label="Código">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start">Código</div>
          </div>
          ${productData.code}
        </div>
        <div class="table-item" data-label="Designação">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Designação</div>
          </div>
          <div class="border border-dark px-2 py-1 rounded-pill">${productData.designation}</div>
        </div>
        <div class="table-item" data-label="Quantidade">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Quantidade</div>
          </div>
          <div class="quantity-selector d-inline-flex align-items-center rounded-pill p-1">
            <button class="btn btn-sm rounded-circle btn-dark" type="button" data-quantity="minus" aria-label="Diminuir quantidade">
              <svg class="icon icon-minus checkmark-icon" aria-hidden="true" focusable="false">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-minus" />
              </svg>
            </button>
            <input type="text" class="form-control-plaintext text-center" value="1" data-quantity="input" aria-label="Quantidade do produto">
            <button class="btn btn-sm rounded-circle btn-dark" type="button" data-quantity="plus" aria-label="Aumentar quantidade">
              <svg class="icon icon-plus" aria-hidden="true" focusable="false">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-plus" />
              </svg>
            </button>
          </div>
        </div>
        <div class="table-item" data-label="Preço Unit.">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Preço Unit.</div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <div class="border border-dark px-2 py-1 rounded-pill">${productData.price}</div><span>€</span>
          </div>
        </div>
        <div class="table-item" data-label="Desc. Cliente">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Desc. Cliente</div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <div class="border border-dark px-2 py-1 rounded-pill">0</div><span>%</span>
          </div>
        </div>
        <div class="table-item" data-label="Desc. Artigo">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Desc. Artigo</div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <div class="border border-dark px-2 py-1 rounded-pill">0</div><span>%</span>
          </div>
        </div>
        <div class="table-item" data-label="Desc. Artigo 2">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Desc. Artigo 2</div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <div class="border border-dark px-2 py-1 rounded-pill">0</div><span>%</span>
          </div>
        </div>
        <div class="table-item" data-label="Total">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Total</div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <div class="">${productData.price}€</div>
          </div>
        </div>
        <div class="table-item" data-label="Encomendar & ALTA">
          <div class="table-body-mobile d-flex d-xl-none">
            <div class="table-item mb-0 fw-semibold text-start mt-2">Encomendar & ALTA</div>
          </div>
          <label class="custom-checkbox">
            <input type="checkbox" class="custom-checkbox__input" name="order_alta_${rowId}">
            <span class="custom-checkbox__checkmark"></span>
          </label>
        </div>
        <div class="table-item" data-label="Eliminar">
          <div class="d-none d-xl-block">
            <a href="#" class="btn btn-outline-dark rounded-circle p-2 lh-1 btn-remove-budget-item" data-row-id="${rowId}" aria-label="Eliminar">
              <svg class="icon icon-trash">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-trash"></use>
              </svg>
            </a>
          </div>
          <div class="d-xl-none text-start">
            <a href="#" class="btn btn-outline-dark rounded-pill d-inline align-items-center gap-2 btn-lg btn-remove-budget-item" data-row-id="${rowId}" aria-label="Eliminar">
              <span>Eliminar</span>
              <svg class="icon icon-trash">
                <use xlink:href="${basePath}/assets/icomoon/symbol-defs.svg#icon-trash"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    `;

    return rowHTML;
  }

  // Listener para botões de adicionar produto
  productsTable.addEventListener("click", function (e) {
    const addButton = e.target.closest("[aria-label*='Adicionar']");

    if (addButton) {
      e.preventDefault();

      // Encontrar a linha do produto
      const productRow = addButton.closest(".table-body");

      if (!productRow) {
        console.error("Linha do produto não encontrada");
        return;
      }

      // Extrair dados do produto
      const productData = {
        code:
          productRow
            .querySelector("[data-label='Código']")
            ?.textContent.trim() || "AQ271362",
        designation:
          productRow
            .querySelector("[data-label='Designação']")
            ?.textContent.trim() ||
          "644342 Valv.Zona 3 vias motorizada 1/2 -230V Solar",
        price:
          productRow
            .querySelector("[data-label='Preço unit.']")
            ?.textContent.trim()
            .replace("€", "")
            .trim() || "140.93",
      };

      // Criar nova linha
      const newRow = createBudgetRow(productData);

      // Adicionar ao orçamento (antes do footer)
      const tableFooter = budgetTable.querySelector(".table-footer");
      if (tableFooter) {
        tableFooter.insertAdjacentHTML("beforebegin", newRow);
      } else {
        budgetTable.insertAdjacentHTML("beforeend", newRow);
      }

      // Scroll suave para o topo da tabela
      budgetTable.scrollIntoView({ behavior: "smooth", block: "start" });

      // Feedback visual (opcional)
      const lastAddedRow = budgetTable.querySelector(`[data-row-id]`);
      if (lastAddedRow) {
        lastAddedRow.classList.add("highlight-row");
        setTimeout(() => {
          lastAddedRow.classList.remove("highlight-row");
        }, 2000);
      }
    }
  });

  // Listener para botões de remover do orçamento
  budgetTable.addEventListener("click", function (e) {
    const removeButton = e.target.closest(".btn-remove-budget-item");

    if (removeButton) {
      e.preventDefault();
      const rowId = removeButton.dataset.rowId;
      const row = budgetTable.querySelector(`[data-row-id="${rowId}"]`);

      if (row) {
        row.remove();
      }
    }
  });

  // Gerenciar controles de quantidade
  budgetTable.addEventListener("click", function (e) {
    const button = e.target.closest("[data-quantity]");

    if (button) {
      e.preventDefault();
      const action = button.dataset.quantity;
      const row = button.closest(".table-body");
      const input = row.querySelector("[data-quantity='input']");

      if (!input) return;

      let currentValue = parseInt(input.value) || 1;

      if (action === "plus") {
        currentValue++;
      } else if (action === "minus" && currentValue > 1) {
        currentValue--;
      }

      input.value = currentValue;

      // Atualizar o total (multiplicar preço pela quantidade)
      const priceElement = row.querySelector(
        "[data-label='Preço Unit.'] .border",
      );
      const totalElement = row.querySelector(
        "[data-label='Total'] > div > div",
      );

      if (priceElement && totalElement) {
        const unitPrice = parseFloat(priceElement.textContent.trim()) || 0;
        const total = (unitPrice * currentValue).toFixed(2);
        totalElement.textContent = `${total}€`;
      }
    }
  });
});

document.querySelectorAll("#cartOffcanvas .accordion-item").forEach((item) => {
  item.addEventListener("shown.bs.collapse", function () {
    this.parentElement.classList.add("is-open");
  });

  item.addEventListener("hidden.bs.collapse", function () {
    this.parentElement.classList.remove("is-open");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const videoModal = document.getElementById("videoModal");
  const videoIframe = document.getElementById("videoIframe");

  if (videoModal || videoIframe) {
    videoModal.addEventListener("show.bs.modal", function (event) {
      const button = event.relatedTarget;
      const videoId = button.getAttribute("data-bs-videoid");
      const platform = button.getAttribute("data-bs-platform");

      let videoUrl = "";

      if (platform === "youtube") {
        videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0`;
      } else if (platform === "vimeo") {
        videoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&autopause=0`;
      }

      videoIframe.setAttribute("src", videoUrl);
    });
  }
});

const purchaseOffcanvas = document.getElementById("purchasingDepartmentOffcanvas");
if (purchaseOffcanvas) {
  function updateStaffCounter() {
        // 1. Conta quantas checkboxes estão selecionadas
        const checked = purchaseOffcanvas.querySelectorAll('input[name="staffSelection[]"]:checked').length;
        
        // 2. Atualiza todos os números (do título e do botão)
        const counters = purchaseOffcanvas.querySelectorAll('.staff-selected-counter');
        counters.forEach(counter => {
            // Se o counter for o do botão (que já tem parênteses no HTML), ou o do título
            // Vamos simplificar para garantir que o número aparece sempre entre parênteses
            counter.textContent = checked; 
        });

        // 3. Lógica do Singular/Plural
        const singularSpan = purchaseOffcanvas.querySelector('.text-singular');
        const pluralSpan = purchaseOffcanvas.querySelector('.text-plural');

        if (checked > 1) {
            singularSpan.classList.add('d-none');
            pluralSpan.classList.remove('d-none');
        } else {
            singularSpan.classList.remove('d-none');
            pluralSpan.classList.add('d-none');
        }
    }

    // Escuta mudanças nas checkboxes
    purchaseOffcanvas.addEventListener('change', function (e) {
        if (e.target.name === 'staffSelection[]') {
            updateStaffCounter();
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const proposalContainer = document.querySelector(".ar__order-history .product-container");

  // Disable add buttons for products already in the proposal on page load
  if (proposalContainer) {
    const existingNames = Array.from(proposalContainer.querySelectorAll(".product-list-item__info .h6"))
      .map(el => el.textContent.trim());

    document.querySelectorAll(".product-list-item").forEach(function (item) {
      if (item.closest(".product-container") === proposalContainer) return;
      const name = item.querySelector(".product-list-item__info .h6")?.textContent.trim();
      if (name && existingNames.includes(name)) {
        item.querySelectorAll(".add-button").forEach(btn => {
          btn.classList.add("disabled");
          btn.setAttribute("aria-disabled", "true");
        });
      }
    });
  }

  document.addEventListener("click", function (e) {
    const addBtn = e.target.closest(".add-button");
    if (!addBtn) return;

    e.preventDefault();
    if (addBtn.classList.contains("disabled")) return;

    const sourceItem = addBtn.closest(".product-list-item");
    if (!sourceItem || !proposalContainer) return;

    const productName = sourceItem.querySelector(".product-list-item__info .h6")?.textContent.trim();

    // Check if already in proposal
    const alreadyAdded = Array.from(proposalContainer.querySelectorAll(".product-list-item__info .h6"))
      .some(el => el.textContent.trim() === productName);

    if (alreadyAdded) {
      sourceItem.querySelectorAll(".add-button").forEach(btn => {
        btn.classList.add("disabled");
        btn.setAttribute("aria-disabled", "true");
      });
      return;
    }

    const clone = sourceItem.cloneNode(true);

    // Replace add buttons with trash buttons in the clone
    clone.querySelectorAll(".product-list-item__actions").forEach(function (actionsEl) {
      actionsEl.innerHTML = `
        <a href="#" class="text-dark p-0 remove-button" aria-label="Remover">
          <svg class="icon icon-trash-2" width="18" height="18">
            <use xlink:href="../assets/icomoon/symbol-defs.svg#icon-trash-2"></use>
          </svg>
        </a>`;
    });

    // Re-init quantity selector on the cloned item
    const qs = clone.querySelector(".quantity-selector");
    if (qs) {
      const minus = qs.querySelector('[data-quantity="minus"]');
      const plus = qs.querySelector('[data-quantity="plus"]');
      const input = qs.querySelector('[data-quantity="input"]');
      if (minus && plus && input) {
        input.value = 1;
        minus.disabled = true;
        minus.addEventListener("click", function () {
          let v = parseInt(input.value, 10);
          if (v > 1) { input.value = v - 1; }
          minus.disabled = parseInt(input.value, 10) <= 1;
        });
        plus.addEventListener("click", function () {
          let v = parseInt(input.value, 10);
          input.value = v + 1;
          minus.disabled = false;
        });
      }
    }

    proposalContainer.appendChild(clone);

    // Disable the add button immediately after adding
    sourceItem.querySelectorAll(".add-button").forEach(btn => {
      btn.classList.add("disabled");
      btn.setAttribute("aria-disabled", "true");
    });
  });

  // Remove item from proposal container
  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest(".remove-button");
    if (!removeBtn) return;
    e.preventDefault();
    const item = removeBtn.closest(".product-list-item");
    if (!item) return;

    const productName = item.querySelector(".product-list-item__info .h6")?.textContent.trim();
    item.remove();

    // Re-enable add button in search list
    document.querySelectorAll(".product-list-item__info .h6").forEach(function (el) {
      if (el.textContent.trim() === productName) {
        el.closest(".product-list-item")?.querySelectorAll(".add-button").forEach(btn => {
          btn.classList.remove("disabled");
          btn.removeAttribute("aria-disabled");
        });
      }
    });
  });
});

// Delegated handler: funciona mesmo se o script for carregado depois do DOM
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-open-offcanvas-after-modal="1"]');
  if (!btn) return;

  const modalElement = btn.closest('.modal');
  const targetSelector = btn.getAttribute('data-open-offcanvas-target') || '#cartOffcanvas';

  if (modalElement) {
    // Espera pelo fecho do modal e simula o clique no trigger do carrinho
    modalElement.addEventListener('hidden.bs.modal', function () {
      const cartTrigger = document.querySelector(`[data-bs-target="${targetSelector}"], [href="${targetSelector}"]`);
      if (cartTrigger) {
        cartTrigger.click();
      }
    }, { once: true });
  }
});